import React, { useState, useEffect, useCallback, useRef, useMemo, memo } from 'react';
import { collection, getDocs, addDoc, updateDoc, deleteDoc, doc, writeBatch, getDoc, setDoc } from 'firebase/firestore';
import { db } from '../../firebase';
import { useAuth } from '../../hooks/useAuth';
import { PRODUCT_TYPES } from '../../constants';
import { formatPrice } from '../../utils';
import * as XLSX from 'xlsx';
import './ProductList.css';

// --- Sub-Components (Memoized for Performance) ---
const PileSettingsPanel = memo(({ title = "Pile Ek Ücret Ayarları (₺)", extraPrices, setExtraPrices, isSavingSettings, handleSaveSettings }) => {
  return (
    <div className="settings-panel">
      <div className="settings-panel-header">
        <i className="fas fa-cut"></i>
        <h4>{title}</h4>
      </div>
      <div className="settings-grid">
        <div className="price-group-wrapper">
          <span className="price-group-name"><i className="fas fa-layer-group" style={{ fontSize: '0.8rem' }}></i>S Pile</span>
          <div className="price-group-grid">
            <div className="price-field"><label>Maliyet</label><input type="number" className="modern-settings-input" value={extraPrices.sPile.cost} onChange={(e) => setExtraPrices(p => ({ ...p, sPile: { ...p.sPile, cost: e.target.value } }))} /></div>
            <div className="price-field"><label>Perakende</label><input type="number" className="modern-settings-input" value={extraPrices.sPile.retail} onChange={(e) => setExtraPrices(p => ({ ...p, sPile: { ...p.sPile, retail: e.target.value } }))} /></div>
            <div className="price-field"><label>Toptan</label><input type="number" className="modern-settings-input" value={extraPrices.sPile.wholesale} onChange={(e) => setExtraPrices(p => ({ ...p, sPile: { ...p.sPile, wholesale: e.target.value } }))} /></div>
          </div>
        </div>
        <div className="price-group-wrapper">
          <span className="price-group-name"><i className="fas fa-layer-group" style={{ fontSize: '0.8rem' }}></i>Amerikan 2'li</span>
          <div className="price-group-grid">
            <div className="price-field"><label>Maliyet</label><input type="number" className="modern-settings-input" value={extraPrices.american2.cost} onChange={(e) => setExtraPrices(p => ({ ...p, american2: { ...p.american2, cost: e.target.value } }))} /></div>
            <div className="price-field"><label>Perakende</label><input type="number" className="modern-settings-input" value={extraPrices.american2.retail} onChange={(e) => setExtraPrices(p => ({ ...p, american2: { ...p.american2, retail: e.target.value } }))} /></div>
            <div className="price-field"><label>Toptan</label><input type="number" className="modern-settings-input" value={extraPrices.american2.wholesale} onChange={(e) => setExtraPrices(p => ({ ...p, american2: { ...p.american2, wholesale: e.target.value } }))} /></div>
          </div>
        </div>
        <div className="price-group-wrapper">
          <span className="price-group-name"><i className="fas fa-layer-group" style={{ fontSize: '0.8rem' }}></i>Amerikan 3'lü</span>
          <div className="price-group-grid">
            <div className="price-field"><label>Maliyet</label><input type="number" className="modern-settings-input" value={extraPrices.american3.cost} onChange={(e) => setExtraPrices(p => ({ ...p, american3: { ...p.american3, cost: e.target.value } }))} /></div>
            <div className="price-field"><label>Perakende</label><input type="number" className="modern-settings-input" value={extraPrices.american3.retail} onChange={(e) => setExtraPrices(p => ({ ...p, american3: { ...p.american3, retail: e.target.value } }))} /></div>
            <div className="price-field"><label>Toptan</label><input type="number" className="modern-settings-input" value={extraPrices.american3.wholesale} onChange={(e) => setExtraPrices(p => ({ ...p, american3: { ...p.american3, wholesale: e.target.value } }))} /></div>
          </div>
        </div>
        <div className="price-group-wrapper">
          <span className="price-group-name"><i className="fas fa-layer-group" style={{ fontSize: '0.8rem' }}></i>Kapsül Pile</span>
          <div className="price-group-grid">
            <div className="price-field"><label>Maliyet</label><input type="number" className="modern-settings-input" value={extraPrices.kapsul.cost} onChange={(e) => setExtraPrices(p => ({ ...p, kapsul: { ...p.kapsul, cost: e.target.value } }))} /></div>
            <div className="price-field"><label>Perakende</label><input type="number" className="modern-settings-input" value={extraPrices.kapsul.retail} onChange={(e) => setExtraPrices(p => ({ ...p, kapsul: { ...p.kapsul, retail: e.target.value } }))} /></div>
            <div className="price-field"><label>Toptan</label><input type="number" className="modern-settings-input" value={extraPrices.kapsul.wholesale} onChange={(e) => setExtraPrices(p => ({ ...p, kapsul: { ...p.kapsul, wholesale: e.target.value } }))} /></div>
          </div>
        </div>
        <button className="btn-save" onClick={() => handleSaveSettings()} disabled={isSavingSettings} style={{ borderRadius: '10px' }}>
          {isSavingSettings ? '...' : 'Kaydet'}
        </button>
      </div>
    </div>
  );
});

const ProductRow = memo(({ product, index, activeTypeTab, isAdmin, isSatisci, isMontajci, onEdit, onDelete, formatPrice }) => {
  return (
    <tr key={product.id}>
      <td className="row-num">{index + 1}</td>
      <td className="product-name">{product.name}</td>

      {(activeTypeTab === 'ahsapJaluzi') ? (
        <>
          {[
            { label: 'merdivenIpli', cost: product.merdivenIpliMaliyet, price: product.merdivenIpliFiyat, wholesale: product.merdivenIpliToptan },
            { label: 'kurdeleli', cost: product.kurdeleliMaliyet, price: product.kurdeleliFiyat, wholesale: product.kurdeleliToptan },
            { label: 'merdivenIpliReduktorlu', cost: product.merdivenIpliReduktorluMaliyet, price: product.merdivenIpliReduktorluFiyat, wholesale: product.merdivenIpliReduktorluToptan },
            { label: 'kurdelaliReduktorlu', cost: product.kurdelaliReduktorluMaliyet, price: product.kurdelaliReduktorluFiyat, wholesale: product.kurdelaliReduktorluToptan }
          ].map((variant, i) => (
            <td key={i} className="product-price-cell senior-design">
              <div className="price-group-vertical">
                <div className="price-row cost" title="Maliyet">
                  <span className="price-icon"><i className="fas fa-coins"></i></span>
                  <span className="price-value">{variant.cost > 0 ? formatPrice(variant.cost) : '—'} ₺</span>
                </div>
                <div className="price-row retail" title="Perakende Satış">
                  <span className="price-icon"><i className="fas fa-tag"></i></span>
                  <span className="price-value">{variant.price > 0 ? formatPrice(variant.price) : '—'} ₺</span>
                </div>
                <div className="price-row wholesale" title="Toptan Satış">
                  <span className="price-icon"><i className="fas fa-percent"></i></span>
                  <span className="price-value">{variant.wholesale > 0 ? formatPrice(variant.wholesale) : '—'} ₺</span>
                </div>
              </div>
            </td>
          ))}
        </>
      ) : activeTypeTab === 'rustik' ? (
        <></>
      ) : (
        <>
          <td className="product-cost">
            {product.cost > 0
              ? <span className="cost-badge">{formatPrice(product.cost)} ₺</span>
              : <span className="no-cost">—</span>
            }
          </td>
          <td className="product-price">
            <span className="price-badge">{formatPrice(product.unitPrice)} ₺</span>
          </td>
          <td className="product-price">
            {product.wholesalePrice > 0
              ? <span className="price-badge wholesale-badge">{formatPrice(product.wholesalePrice)} ₺</span>
              : <span className="no-cost">—</span>
            }
          </td>
        </>
      )}
      {(isAdmin || isSatisci) && !isMontajci && (
        <td className="product-actions">
          <button className="btn-edit-product" onClick={() => onEdit(product)} title="Düzenle">
            <i className="fas fa-edit"></i>
          </button>
          <button className="btn-delete-product" onClick={() => onDelete(product)} title="Sil">
            <i className="fas fa-trash"></i>
          </button>
        </td>
      )}
    </tr>
  );
});

const ProductListTable = memo(({
  filteredProducts,
  activeTypeTab,
  isAdmin,
  isSatisci,
  isMontajci,
  handleEdit,
  setDeleteModal,
  formatPrice
}) => {
  if (filteredProducts.length === 0) return null;

  return (
    <table className="product-table">
      <thead>
        <tr>
          <th>#</th>
          <th>Ürün Adı</th>
          {activeTypeTab === 'ahsapJaluzi' ? (
            <>
              <th>Merdiven İpli</th>
              <th>Kurdeleli</th>
              <th>M. İpli Red.</th>
              <th>Kur. Red.</th>
            </>
          ) : activeTypeTab === 'rustik' ? (
            <></>
          ) : (
            <>
              <th>Maliyet</th>
              <th>Birim Fiyat</th>
              <th>Toptan Fiyat</th>
            </>
          )}
          {(isAdmin || isSatisci) && !isMontajci && <th>İşlemler</th>}
        </tr>
      </thead>
      <tbody>
        {filteredProducts.map((product, index) => (
          <ProductRow
            key={product.id}
            product={product}
            index={index}
            activeTypeTab={activeTypeTab}
            isAdmin={isAdmin}
            isSatisci={isSatisci}
            isMontajci={isMontajci}
            onEdit={handleEdit}
            onDelete={setDeleteModal}
            formatPrice={formatPrice}
          />
        ))}
      </tbody>
    </table>
  );
});

const ProductList = () => {
  const { isAdmin, isSatisci, isMontajci } = useAuth();

  const [products, setProducts] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [isExcelLoading, setIsExcelLoading] = useState(false);
  const [activeTypeTab, setActiveTypeTab] = useState(Object.keys(PRODUCT_TYPES)[0]);
  const [searchQuery, setSearchQuery] = useState('');
  const [isSavingSettings, setIsSavingSettings] = useState(false);
  const fileInputRef = useRef(null);

  const [extraPrices, setExtraPrices] = useState({
    sPile: { cost: '', retail: '', wholesale: '' },
    american2: { cost: '', retail: '', wholesale: '' },
    american3: { cost: '', retail: '', wholesale: '' },
    kapsul: { cost: '', retail: '', wholesale: '' }
  });
  const [kanatExtraPrices, setKanatExtraPrices] = useState({
    sPile: { cost: '', retail: '', wholesale: '' },
    american2: { cost: '', retail: '', wholesale: '' },
    american3: { cost: '', retail: '', wholesale: '' },
    kapsul: { cost: '', retail: '', wholesale: '' }
  });
  const [ahsapJaluziExtras, setAhsapJaluziExtras] = useState({
    zigil: { cost: '', retail: '', wholesale: '' }
  });
  const [metalJaluziExtras, setMetalJaluziExtras] = useState({
    zigil: { cost: '', retail: '', wholesale: '' },
    reduktor: { cost: '', retail: '', wholesale: '' },
    ikiCamArasi: { cost: '', retail: '', wholesale: '' }
  });
  const [exchangeRates, setExchangeRates] = useState({ USD: 1, EUR: 1 });
  const [storExtras, setStorExtras] = useState({
    jumbo: { cost: '', retail: '', wholesale: '' },
    altEtekDilim: { cost: '', retail: '', wholesale: '' },
    kapaliKasa: { cost: '', retail: '', wholesale: '' },
    altEtekLazer: { cost: '', retail: '', wholesale: '' },
    dekoratifLama: { cost: '', retail: '', wholesale: '' },
    dekoratifKasa: { cost: '', retail: '', wholesale: '' },
    altEtekBeyazIs: { cost: '', retail: '', wholesale: '' }
  });
  const [zebraExtras, setZebraExtras] = useState({
    jumbo: { cost: '', retail: '', wholesale: '' },
    altEtekDilim: { cost: '', retail: '', wholesale: '' },
    kapaliKasa: { cost: '', retail: '', wholesale: '' }
  });
  const [dikeyExtras, setDikeyExtras] = useState({
    fon: { cost: '', retail: '', wholesale: '' },
    fonList: []
  });
  const [katlamaliExtras, setKatlamaliExtras] = useState({ mekanizmaList: [] });
  const [newKatlamaliMekanizma, setNewKatlamaliMekanizma] = useState({ type: '', cost: '', price: '', wholesale: '' });
  const [isKatlamaliMekanizmaCollapsed, setIsKatlamaliMekanizmaCollapsed] = useState(true);
  const [rustikExtras, setRustikExtras] = useState({
    ayakModelList: [],
    ayakCapList: [],
    ayakUzunlukList: [],
    ayakRenkKoduList: []
  });
  const [motorSettings, setMotorSettings] = useState({
    motor: { cost: '', retail: '', wholesale: '', currency: 'USD', specialRateRetail: '', specialRateWholesale: '' },
    stor: { cost: '', retail: '', wholesale: '', currency: 'USD', specialRateRetail: '', specialRateWholesale: '' },
    zebra: { cost: '', retail: '', wholesale: '', currency: 'USD', specialRateRetail: '', specialRateWholesale: '' },
    ahsapJaluzi: { cost: '', retail: '', wholesale: '', currency: 'USD', specialRateRetail: '', specialRateWholesale: '' },
    metalJaluzi: { cost: '', retail: '', wholesale: '', currency: 'USD', specialRateRetail: '', specialRateWholesale: '' },
    dikeyPerde: { cost: '', retail: '', wholesale: '', currency: 'USD', specialRateRetail: '', specialRateWholesale: '' },
    dikeyPvc: { cost: '', retail: '', wholesale: '', currency: 'USD', specialRateRetail: '', specialRateWholesale: '' },
    dikeyStor: { cost: '', retail: '', wholesale: '', currency: 'USD', specialRateRetail: '', specialRateWholesale: '' },
    katlamaliPerde: { cost: '', retail: '', wholesale: '', currency: 'USD', specialRateRetail: '', specialRateWholesale: '' }
  });
  const [newRustikModel, setNewRustikModel] = useState('');
  const [newRustikCap, setNewRustikCap] = useState('');
  const [newRustikUzunluk, setNewRustikUzunluk] = useState('');
  const [newRustikRenk, setNewRustikRenk] = useState('');
  const [isRustikSettingsCollapsed, setIsRustikSettingsCollapsed] = useState(true);
  const [isRustikModelCollapsed, setIsRustikModelCollapsed] = useState(true);
  const [isRustikCapCollapsed, setIsRustikCapCollapsed] = useState(true);
  const [isRustikUzunlukCollapsed, setIsRustikUzunlukCollapsed] = useState(true);
  const [isRustikRenkCollapsed, setIsRustikRenkCollapsed] = useState(true);

  const [editingRustikModel, setEditingRustikModel] = useState({ index: null, value: '' });
  const [editingRustikCap, setEditingRustikCap] = useState({ index: null, value: '' });
  const [editingRustikUzunluk, setEditingRustikUzunluk] = useState({ index: null, value: '' });
  const [editingRustikRenk, setEditingRustikRenk] = useState({ index: null, value: '' });

  useEffect(() => {
    // Fetch Settings
    const fetchSettings = async () => {
      try {
        const settingsRef = doc(db, 'settings', 'global');
        const docSnap = await getDoc(settingsRef);
        if (docSnap.exists()) {
          const data = docSnap.data();
          setExtraPrices({
            sPile: { cost: data.sPileCost !== undefined ? data.sPileCost : '', retail: data.sPilePrice !== undefined ? data.sPilePrice : '', wholesale: data.sPileWholesale !== undefined ? data.sPileWholesale : '' },
            american2: { cost: data.american2Cost !== undefined ? data.american2Cost : '', retail: data.american2Price !== undefined ? data.american2Price : '', wholesale: data.american2Wholesale !== undefined ? data.american2Wholesale : '' },
            american3: { cost: data.american3Cost !== undefined ? data.american3Cost : '', retail: data.american3Price !== undefined ? data.american3Price : '', wholesale: data.american3Wholesale !== undefined ? data.american3Wholesale : '' },
            kapsul: { cost: data.kapsulCost !== undefined ? data.kapsulCost : '', retail: data.kapsulPrice !== undefined ? data.kapsulPrice : '', wholesale: data.kapsulWholesale !== undefined ? data.kapsulWholesale : '' },
          });
          setKanatExtraPrices({
            sPile: {
              cost: data.kanatSPileCost !== undefined ? data.kanatSPileCost : (data.sPileCost !== undefined ? data.sPileCost : ''),
              retail: data.kanatSPilePrice !== undefined ? data.kanatSPilePrice : (data.sPilePrice !== undefined ? data.sPilePrice : ''),
              wholesale: data.kanatSPileWholesale !== undefined ? data.kanatSPileWholesale : (data.sPileWholesale !== undefined ? data.sPileWholesale : '')
            },
            american2: {
              cost: data.kanatAmerican2Cost !== undefined ? data.kanatAmerican2Cost : (data.american2Cost !== undefined ? data.american2Cost : ''),
              retail: data.kanatAmerican2Price !== undefined ? data.kanatAmerican2Price : (data.american2Price !== undefined ? data.american2Price : ''),
              wholesale: data.kanatAmerican2Wholesale !== undefined ? data.kanatAmerican2Wholesale : (data.american2Wholesale !== undefined ? data.american2Wholesale : '')
            },
            american3: {
              cost: data.kanatAmerican3Cost !== undefined ? data.kanatAmerican3Cost : (data.american3Cost !== undefined ? data.american3Cost : ''),
              retail: data.kanatAmerican3Price !== undefined ? data.kanatAmerican3Price : (data.american3Price !== undefined ? data.american3Price : ''),
              wholesale: data.kanatAmerican3Wholesale !== undefined ? data.kanatAmerican3Wholesale : (data.american3Wholesale !== undefined ? data.american3Wholesale : '')
            },
            kapsul: {
              cost: data.kanatKapsulCost !== undefined ? data.kanatKapsulCost : (data.kapsulCost !== undefined ? data.kapsulCost : ''),
              retail: data.kanatKapsulPrice !== undefined ? data.kanatKapsulPrice : (data.kapsulPrice !== undefined ? data.kapsulPrice : ''),
              wholesale: data.kanatKapsulWholesale !== undefined ? data.kanatKapsulWholesale : (data.kapsulWholesale !== undefined ? data.kapsulWholesale : '')
            }
          });
          setAhsapJaluziExtras({
            zigil: { cost: data.zigilCost || '', retail: data.zigilPrice || '', wholesale: data.zigilWholesale || '' },
            reduktor: { cost: data.reduktorCost || '', retail: data.reduktorPrice || '', wholesale: data.reduktorWholesale || '' },
            kurdele: { cost: data.kurdelaCost || '', retail: data.kurdelaPrice || '', wholesale: data.kurdelaWholesale || '' }
          });
          setMetalJaluziExtras({
            zigil: { cost: data.metalZigilCost || '', retail: data.metalZigilPrice || '', wholesale: data.metalZigilWholesale || '' },
            reduktor: { cost: data.metalReduktorCost || '', retail: data.metalReduktorPrice || '', wholesale: data.metalReduktorWholesale || '' },
            ikiCamArasi: { cost: data.ikiCamArasiCost || '', retail: data.ikiCamArasiPrice || '', wholesale: data.ikiCamArasiWholesale || '' }
          });
          setStorExtras({
            jumbo: { cost: data.storJumboCost || '', retail: data.storJumboPrice || '', wholesale: data.storJumboWholesale || '' },
            altEtekDilim: { cost: data.storAltEtekDilimCost || '', retail: data.storAltEtekDilimPrice || '', wholesale: data.storAltEtekDilimWholesale || '' },
            kapaliKasa: { cost: data.storKapaliKasaCost || '', retail: data.storKapaliKasaPrice || '', wholesale: data.storKapaliKasaWholesale || '' },
            altEtekLazer: { cost: data.storAltEtekLazerCost || '', retail: data.storAltEtekLazerPrice || '', wholesale: data.storAltEtekLazerWholesale || '' },
            dekoratifLama: { cost: data.storDekoratifLamaCost || '', retail: data.storDekoratifLamaPrice || '', wholesale: data.storDekoratifLamaWholesale || '' },
            dekoratifKasa: { cost: data.storDekoratifKasaCost || '', retail: data.storDekoratifKasaPrice || '', wholesale: data.storDekoratifKasaWholesale || '' },
            altEtekBeyazIs: { cost: data.storAltEtekBeyazIsCost || '', retail: data.storAltEtekBeyazIsPrice || '', wholesale: data.storAltEtekBeyazIsWholesale || '' }
          });
          setZebraExtras({
            jumbo: { cost: data.zebraJumboCost || '', retail: data.zebraJumboPrice || '', wholesale: data.zebraJumboWholesale || '' },
            altEtekDilim: { cost: data.zebraAltEtekDilimCost || '', retail: data.zebraAltEtekDilimPrice || '', wholesale: data.zebraAltEtekDilimWholesale || '' },
            kapaliKasa: { cost: data.zebraKapaliKasaCost || '', retail: data.zebraKapaliKasaPrice || '', wholesale: data.zebraKapaliKasaWholesale || '' }
          });
          setDikeyExtras({
            fon: { cost: data.dikeyFonCost || '', retail: data.dikeyFonPrice || '', wholesale: data.dikeyFonWholesale || '' },
            fonList: data.dikeyFonList || []
          });
          setKatlamaliExtras({
            mekanizmaList: data.katlamaliMekanizmaList || []
          });
          setRustikExtras({
            ayakModelList: data.rustikAyakModelList || [],
            ayakCapList: data.rustikAyakCapList || [],
            ayakUzunlukList: data.rustikAyakUzunlukList || [],
            ayakRenkKoduList: data.rustikAyakRenkKoduList || []
          });
          const loadedMotorSettings = {};
          ['stor', 'zebra', 'ahsapJaluzi', 'metalJaluzi', 'dikeyPerde', 'dikeyPvc', 'dikeyStor', 'katlamaliPerde'].forEach(type => {
            loadedMotorSettings[type] = {
              cost: data[`${type}MotorCost`] !== undefined ? data[`${type}MotorCost`] : '',
              retail: data[`${type}MotorRetail`] !== undefined ? data[`${type}MotorRetail`] : '',
              wholesale: data[`${type}MotorWholesale`] !== undefined ? data[`${type}MotorWholesale`] : '',
              currency: data[`${type}MotorCurrency`] || 'USD',
              specialRateRetail: data[`${type}MotorSpecialRateRetail`] || '',
              specialRateWholesale: data[`${type}MotorSpecialRateWholesale`] || ''
            };
          });
          setMotorSettings(loadedMotorSettings);
        }
      } catch (err) {
        console.error('Settings fetch error:', err);
      }
    };
    fetchSettings();

    // Fetch Exchange Rates
    const fetchRates = async () => {
      try {
        const res = await fetch('https://open.er-api.com/v6/latest/USD');
        const data = await res.json();
        if (data && data.rates && data.rates.TRY && data.rates.EUR) {
          const usdToTry = data.rates.TRY;
          const eurToTry = data.rates.TRY / data.rates.EUR;
          setExchangeRates({ USD: usdToTry.toFixed(2), EUR: eurToTry.toFixed(2) });
        }
      } catch (err) {
        console.error('Exchange rates error:', err);
      }
    };
    fetchRates();
  }, []);

  const handleSaveMotorSettings = async (type) => {
    try {
      setIsSavingSettings(true);
      const settingsRef = doc(db, 'settings', 'global');
      const settings = motorSettings[type];

      const updateData = {
        [`${type}MotorCost`]: Number(settings.cost),
        [`${type}MotorRetail`]: Number(settings.retail),
        [`${type}MotorWholesale`]: Number(settings.wholesale),
        [`${type}MotorCurrency`]: settings.currency,
        [`${type}MotorSpecialRateRetail`]: Number(settings.specialRateRetail),
        [`${type}MotorSpecialRateWholesale`]: Number(settings.specialRateWholesale)
      };

      await updateDoc(settingsRef, updateData);
      setExcelModal({ show: true, type: 'success', title: 'Başarılı', message: `${PRODUCT_TYPES[type]?.label || type} motor ve kur ayarları güncellendi.` });
    } catch (error) {
      console.error('Ayarlar kaydedilirken hata:', error);
      setExcelModal({ show: true, type: 'error', title: 'Hata', message: 'Ayarlar kaydedilemedi: ' + error.message });
    } finally {
      setIsSavingSettings(false);
    }
  };

  const handleSaveSettings = async (overrideData = null) => {
    setIsSavingSettings(true);
    try {
      const settingsRef = doc(db, 'settings', 'global');
      let updateData = overrideData || {};

      if (!overrideData) {
        const typeKeys = {
          ahsapJaluzi: 'ahsapJaluzi',
          metalJaluzi: 'metalJaluzi',
          stor: 'stor',
          zebra: 'zebra',
          dikeyPerde: 'dikeyPerde',
          dikeyPvc: 'dikeyPvc',
          dikeyStor: 'dikeyStor',
          katlamaliPerde: 'katlamaliPerde'
        };

        if (typeKeys[activeTypeTab]) {
          const type = typeKeys[activeTypeTab];
          const settings = motorSettings[type];
          updateData[`${type}MotorCost`] = Number(settings.cost);
          updateData[`${type}MotorRetail`] = Number(settings.retail);
          updateData[`${type}MotorWholesale`] = Number(settings.wholesale);
          updateData[`${type}MotorCurrency`] = settings.currency;
          updateData[`${type}MotorSpecialRateRetail`] = Number(settings.specialRateRetail);
          updateData[`${type}MotorSpecialRateWholesale`] = Number(settings.specialRateWholesale);
        }

        if (activeTypeTab === 'tul') {
          updateData = {
            ...updateData,
            sPileCost: Number(extraPrices.sPile.cost) || 0,
            sPilePrice: Number(extraPrices.sPile.retail) || 0,
            sPileWholesale: Number(extraPrices.sPile.wholesale) || 0,
            american2Cost: Number(extraPrices.american2.cost) || 0,
            american2Price: Number(extraPrices.american2.retail) || 0,
            american2Wholesale: Number(extraPrices.american2.wholesale) || 0,
            american3Cost: Number(extraPrices.american3.cost) || 0,
            american3Price: Number(extraPrices.american3.retail) || 0,
            american3Wholesale: Number(extraPrices.american3.wholesale) || 0,
            kapsulCost: Number(extraPrices.kapsul.cost) || 0,
            kapsulPrice: Number(extraPrices.kapsul.retail) || 0,
            kapsulWholesale: Number(extraPrices.kapsul.wholesale) || 0
          };
        } else if (activeTypeTab === 'kanat') {
          updateData = {
            ...updateData,
            kanatSPileCost: Number(kanatExtraPrices.sPile.cost) || 0,
            kanatSPilePrice: Number(kanatExtraPrices.sPile.retail) || 0,
            kanatSPileWholesale: Number(kanatExtraPrices.sPile.wholesale) || 0,
            kanatAmerican2Cost: Number(kanatExtraPrices.american2.cost) || 0,
            kanatAmerican2Price: Number(kanatExtraPrices.american2.retail) || 0,
            kanatAmerican2Wholesale: Number(kanatExtraPrices.american2.wholesale) || 0,
            kanatAmerican3Cost: Number(kanatExtraPrices.american3.cost) || 0,
            kanatAmerican3Price: Number(kanatExtraPrices.american3.retail) || 0,
            kanatAmerican3Wholesale: Number(kanatExtraPrices.american3.wholesale) || 0,
            kanatKapsulCost: Number(kanatExtraPrices.kapsul.cost) || 0,
            kanatKapsulPrice: Number(kanatExtraPrices.kapsul.retail) || 0,
            kanatKapsulWholesale: Number(kanatExtraPrices.kapsul.wholesale) || 0
          };
        } else if (activeTypeTab === 'ahsapJaluzi') {
          updateData = {
            ...updateData,
            zigilCost: Number(ahsapJaluziExtras.zigil.cost),
            zigilPrice: Number(ahsapJaluziExtras.zigil.retail),
            zigilWholesale: Number(ahsapJaluziExtras.zigil.wholesale),
            reduktorCost: Number(ahsapJaluziExtras.reduktor.cost),
            reduktorPrice: Number(ahsapJaluziExtras.reduktor.retail),
            reduktorWholesale: Number(ahsapJaluziExtras.reduktor.wholesale),
            kurdelaCost: Number(ahsapJaluziExtras.kurdele.cost),
            kurdelaPrice: Number(ahsapJaluziExtras.kurdele.retail),
            kurdelaWholesale: Number(ahsapJaluziExtras.kurdele.wholesale)
          };
        } else if (activeTypeTab === 'metalJaluzi') {
          updateData = {
            ...updateData,
            metalZigilCost: Number(metalJaluziExtras.zigil.cost),
            metalZigilPrice: Number(metalJaluziExtras.zigil.retail),
            metalZigilWholesale: Number(metalJaluziExtras.zigil.wholesale),
            metalReduktorCost: Number(metalJaluziExtras.reduktor.cost),
            metalReduktorPrice: Number(metalJaluziExtras.reduktor.retail),
            metalReduktorWholesale: Number(metalJaluziExtras.reduktor.wholesale),
            ikiCamArasiCost: Number(metalJaluziExtras.ikiCamArasi.cost),
            ikiCamArasiPrice: Number(metalJaluziExtras.ikiCamArasi.retail),
            ikiCamArasiWholesale: Number(metalJaluziExtras.ikiCamArasi.wholesale)
          };
        } else if (activeTypeTab === 'stor') {
          updateData = {
            ...updateData,
            storJumboCost: Number(storExtras.jumbo.cost),
            storJumboPrice: Number(storExtras.jumbo.retail),
            storJumboWholesale: Number(storExtras.jumbo.wholesale),
            storAltEtekDilimCost: Number(storExtras.altEtekDilim.cost),
            storAltEtekDilimPrice: Number(storExtras.altEtekDilim.retail),
            storAltEtekDilimWholesale: Number(storExtras.altEtekDilim.wholesale),
            storKapaliKasaCost: Number(storExtras.kapaliKasa.cost),
            storKapaliKasaPrice: Number(storExtras.kapaliKasa.retail),
            storKapaliKasaWholesale: Number(storExtras.kapaliKasa.wholesale),
            storAltEtekLazerCost: Number(storExtras.altEtekLazer.cost),
            storAltEtekLazerPrice: Number(storExtras.altEtekLazer.retail),
            storAltEtekLazerWholesale: Number(storExtras.altEtekLazer.wholesale),
            storDekoratifLamaCost: Number(storExtras.dekoratifLama.cost),
            storDekoratifLamaPrice: Number(storExtras.dekoratifLama.retail),
            storDekoratifLamaWholesale: Number(storExtras.dekoratifLama.wholesale),
            storDekoratifKasaCost: Number(storExtras.dekoratifKasa.cost),
            storDekoratifKasaPrice: Number(storExtras.dekoratifKasa.retail),
            storDekoratifKasaWholesale: Number(storExtras.dekoratifKasa.wholesale),
            storAltEtekBeyazIsCost: Number(storExtras.altEtekBeyazIs.cost),
            storAltEtekBeyazIsPrice: Number(storExtras.altEtekBeyazIs.retail),
            storAltEtekBeyazIsWholesale: Number(storExtras.altEtekBeyazIs.wholesale)
          };
        } else if (activeTypeTab === 'zebra') {
          updateData = {
            ...updateData,
            zebraJumboCost: Number(zebraExtras.jumbo.cost),
            zebraJumboPrice: Number(zebraExtras.jumbo.retail),
            zebraJumboWholesale: Number(zebraExtras.jumbo.wholesale),
            zebraAltEtekDilimCost: Number(zebraExtras.altEtekDilim.cost),
            zebraAltEtekDilimPrice: Number(zebraExtras.altEtekDilim.retail),
            zebraAltEtekDilimWholesale: Number(zebraExtras.altEtekDilim.wholesale),
            zebraKapaliKasaCost: Number(zebraExtras.kapaliKasa.cost),
            zebraKapaliKasaPrice: Number(zebraExtras.kapaliKasa.retail),
            zebraKapaliKasaWholesale: Number(zebraExtras.kapaliKasa.wholesale)
          };
        } else if (activeTypeTab === 'dikeyPerde') {
          updateData = {
            ...updateData,
            dikeyFonCost: Number(dikeyExtras.fon.cost),
            dikeyFonPrice: Number(dikeyExtras.fon.retail),
            dikeyFonWholesale: Number(dikeyExtras.fon.wholesale),
            dikeyFonList: dikeyExtras.fonList || []
          };
        } else if (activeTypeTab === 'katlamaliPerde') {
          updateData = {
            ...updateData,
            katlamaliMekanizmaList: katlamaliExtras.mekanizmaList || []
          };
        }
      }

      await setDoc(settingsRef, updateData, { merge: true });
      if (!overrideData) {
        setExcelModal({ show: true, type: 'success', title: 'Başarılı', message: 'Ayarlar başarıyla kaydedildi.' });
      }
    } catch (err) {
      console.error('Settings save error:', err);
      if (!overrideData) {
        setExcelModal({ show: true, type: 'error', title: 'Hata', message: 'Ayarlar kaydedilirken bir hata oluştu.' });
      }
    }
    setIsSavingSettings(false);
  };

  const renderMotorSettings = (type) => {
    const settings = motorSettings[type];
    if (!settings) return null;

    const updateSetting = (field, value) => {
      setMotorSettings(prev => ({
        ...prev,
        [type]: { ...prev[type], [field]: value }
      }));
    };

    return (
      <div className="settings-panel" style={{ marginTop: '20px', border: '1px solid #b04309' }}>
        <div className="settings-panel-header">
          <i className="fas fa-microchip" style={{ color: '#b04309' }}></i>
          <h4>{PRODUCT_TYPES[type]?.label || type} Motor ve Kur Ayarları ({settings.currency})</h4>
        </div>
        <div className="settings-grid">
          <div className="price-group-wrapper">
            <span className="price-group-name">
              <i className="fas fa-tag" style={{ fontSize: '0.8rem' }}></i>
              Birim Ücretler
            </span>
            <div className="price-group-grid">
              <div className="price-field">
                <label>Maliyet</label>
                <input type="number" className="modern-settings-input" value={settings.cost} onChange={(e) => updateSetting('cost', e.target.value)} placeholder="0.00" />
              </div>
              <div className="price-field">
                <label>Perakende</label>
                <input type="number" className="modern-settings-input" value={settings.retail} onChange={(e) => updateSetting('retail', e.target.value)} placeholder="0.00" />
              </div>
              <div className="price-field">
                <label>Toptan</label>
                <input type="number" className="modern-settings-input" value={settings.wholesale} onChange={(e) => updateSetting('wholesale', e.target.value)} placeholder="0.00" />
              </div>
            </div>
          </div>

          <div className="price-group-wrapper">
            <span className="price-group-name">
              <i className="fas fa-coins" style={{ fontSize: '0.8rem' }}></i>
              Döviz & Kur Ayarları
            </span>
            <div className="price-group-grid">
              <div className="price-field">
                <label>Döviz</label>
                <select className="modern-settings-input" value={settings.currency} onChange={(e) => updateSetting('currency', e.target.value)} style={{ padding: '0 8px', width: '100%' }}>
                  <option value="USD">USD</option>
                  <option value="EUR">EUR</option>
                  <option value="TRY">TL</option>
                </select>
              </div>
              <div className="price-field">
                <label>Kur (Per.)</label>
                <input type="number" className="modern-settings-input" value={settings.specialRateRetail} onChange={(e) => updateSetting('specialRateRetail', e.target.value)} placeholder="Otomatik" />
              </div>
              <div className="price-field">
                <label>Kur (Top.)</label>
                <input type="number" className="modern-settings-input" value={settings.specialRateWholesale} onChange={(e) => updateSetting('specialRateWholesale', e.target.value)} placeholder="Otomatik" />
              </div>
            </div>
          </div>

          <button
            className="btn-save"
            onClick={() => handleSaveMotorSettings(type)}
            disabled={isSavingSettings}
            style={{ backgroundColor: '#b04309', borderRadius: '10px' }}
          >
            {isSavingSettings ? '...' : `${PRODUCT_TYPES[type]?.label || type} Ayarlarını Kaydet`}
          </button>
        </div>
      </div>
    );
  };

  // Form state
  const [showForm, setShowForm] = useState(false);
  const [editingProduct, setEditingProduct] = useState(null);
  const [formData, setFormData] = useState({
    name: '',
    productType: Object.keys(PRODUCT_TYPES)[0],
    unitPrice: '',
    wholesalePrice: '',
    cost: '',
    // Jaluziler için ekstra fiyatlandırma
    merdivenIpliFiyat: '',
    merdivenIpliMaliyet: '',
    merdivenIpliToptan: '',
    kurdeleliFiyat: '',
    kurdeleliMaliyet: '',
    kurdeleliToptan: '',
    merdivenIpliReduktorluFiyat: '',
    merdivenIpliReduktorluMaliyet: '',
    merdivenIpliReduktorluToptan: '',
    kurdelaliReduktorluFiyat: '',
    kurdelaliReduktorluMaliyet: '',
    kurdelaliReduktorluToptan: ''
  });
  const [formError, setFormError] = useState(null);
  const [formSuccess, setFormSuccess] = useState(null);
  const [isSaving, setIsSaving] = useState(false);

  // Silme modal
  const [deleteModal, setDeleteModal] = useState(null);
  const [excelModal, setExcelModal] = useState({ show: false, type: '', title: '', message: '', onConfirm: null });

  // Ürünleri Firestore'dan çek
  const fetchProducts = useCallback(async () => {
    setIsLoading(true);
    try {
      const snapshot = await getDocs(collection(db, 'productItems'));
      const data = snapshot.docs.map(d => ({ id: d.id, ...d.data() }));
      // İsme göre sırala
      data.sort((a, b) => (a.name || '').localeCompare(b.name || '', 'tr'));
      setProducts(data);
    } catch (error) {
      console.error('Ürünler yüklenirken hata:', error);
    } finally {
      setIsLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchProducts();
  }, [fetchProducts]);

  // Sekme değişince arama kutusunu sıfırla
  const handleTabChange = (key) => {
    React.startTransition(() => {
      setActiveTypeTab(key);
      setSearchQuery('');
    });
  };

  // Ürün sayılarını memoize et (Performans için)
  const productCounts = useMemo(() => {
    const counts = {};
    products.forEach(p => {
      counts[p.productType] = (counts[p.productType] || 0) + 1;
    });
    return counts;
  }, [products]);

  // Aktif sekmedeki ürünler (arama filtreli - Memoize edildi)
  const filteredProducts = useMemo(() => {
    return products.filter(p => {
      if (p.productType !== activeTypeTab) return false;
      if (!searchQuery.trim()) return true;
      return (p.name || '').toLowerCase().includes(searchQuery.toLowerCase().trim());
    });
  }, [products, activeTypeTab, searchQuery]);

  // Form aç - yeni ürün
  const handleAddNew = () => {
    setEditingProduct(null);
    setFormData({
      name: '',
      productType: activeTypeTab,
      unitPrice: '',
      wholesalePrice: '',
      cost: '',
      merdivenIpliFiyat: '',
      merdivenIpliMaliyet: '',
      merdivenIpliToptan: '',
      kurdeleliFiyat: '',
      kurdeleliMaliyet: '',
      kurdeleliToptan: '',
      merdivenIpliReduktorluFiyat: '',
      merdivenIpliReduktorluMaliyet: '',
      merdivenIpliReduktorluToptan: '',
      kurdelaliReduktorluFiyat: '',
      kurdelaliReduktorluMaliyet: '',
      kurdelaliReduktorluToptan: ''
    });
    setFormError(null);
    setFormSuccess(null);
    setShowForm(true);
  };

  // Form aç - düzenle
  const handleEdit = (product) => {
    setEditingProduct(product);
    setFormData({
      name: product.name || '',
      productType: product.productType || activeTypeTab,
      unitPrice: product.unitPrice || '',
      wholesalePrice: product.wholesalePrice || '',
      cost: product.cost || '',
      merdivenIpliFiyat: product.merdivenIpliFiyat || '',
      merdivenIpliMaliyet: product.merdivenIpliMaliyet || '',
      merdivenIpliToptan: product.merdivenIpliToptan || '',
      kurdeleliFiyat: product.kurdeleliFiyat || '',
      kurdeleliMaliyet: product.kurdeleliMaliyet || '',
      kurdeleliToptan: product.kurdeleliToptan || '',
      merdivenIpliReduktorluFiyat: product.merdivenIpliReduktorluFiyat || '',
      merdivenIpliReduktorluMaliyet: product.merdivenIpliReduktorluMaliyet || '',
      merdivenIpliReduktorluToptan: product.merdivenIpliReduktorluToptan || '',
      kurdelaliReduktorluFiyat: product.kurdelaliReduktorluFiyat || '',
      kurdelaliReduktorluMaliyet: product.kurdelaliReduktorluMaliyet || '',
      kurdelaliReduktorluToptan: product.kurdelaliReduktorluToptan || ''
    });
    setFormError(null);
    setFormSuccess(null);
    setShowForm(true);
  };

  // Form kapat
  const handleCancel = () => {
    setShowForm(false);
    setEditingProduct(null);
    setFormError(null);
  };

  // Kaydet
  const handleSave = async (e) => {
    e.preventDefault();
    setFormError(null);
    setFormSuccess(null);

    if (!formData.name.trim()) {
      setFormError('Ürün adı zorunludur.');
      return;
    }

    const isJaluzi = formData.productType === 'ahsapJaluzi';
    const isRustik = formData.productType === 'rustik';

    if (!isJaluzi && !isRustik && (!formData.unitPrice || isNaN(parseFloat(formData.unitPrice)))) {
      setFormError('Birim fiyat geçerli bir sayı olmalıdır.');
      return;
    }

    setIsSaving(true);
    try {
      let payload = {
        name: formData.name.trim(),
        productType: formData.productType,
        updatedAt: new Date()
      };

      if (isJaluzi) {
        payload = {
          ...payload,
          merdivenIpliFiyat: formData.merdivenIpliFiyat ? parseFloat(formData.merdivenIpliFiyat) : 0,
          merdivenIpliMaliyet: formData.merdivenIpliMaliyet ? parseFloat(formData.merdivenIpliMaliyet) : 0,
          merdivenIpliToptan: formData.merdivenIpliToptan ? parseFloat(formData.merdivenIpliToptan) : 0,
          kurdeleliFiyat: formData.kurdeleliFiyat ? parseFloat(formData.kurdeleliFiyat) : 0,
          kurdeleliMaliyet: formData.kurdeleliMaliyet ? parseFloat(formData.kurdeleliMaliyet) : 0,
          kurdeleliToptan: formData.kurdeleliToptan ? parseFloat(formData.kurdeleliToptan) : 0,
          merdivenIpliReduktorluFiyat: formData.merdivenIpliReduktorluFiyat ? parseFloat(formData.merdivenIpliReduktorluFiyat) : 0,
          merdivenIpliReduktorluMaliyet: formData.merdivenIpliReduktorluMaliyet ? parseFloat(formData.merdivenIpliReduktorluMaliyet) : 0,
          merdivenIpliReduktorluToptan: formData.merdivenIpliReduktorluToptan ? parseFloat(formData.merdivenIpliReduktorluToptan) : 0,
          kurdelaliReduktorluFiyat: formData.kurdelaliReduktorluFiyat ? parseFloat(formData.kurdelaliReduktorluFiyat) : 0,
          kurdelaliReduktorluMaliyet: formData.kurdelaliReduktorluMaliyet ? parseFloat(formData.kurdelaliReduktorluMaliyet) : 0,
          kurdelaliReduktorluToptan: formData.kurdelaliReduktorluToptan ? parseFloat(formData.kurdelaliReduktorluToptan) : 0
        };
      } else if (isRustik) {
        payload = {
          ...payload,
          unitPrice: 0,
          cost: 0
        };
      } else {
        payload = {
          ...payload,
          unitPrice: parseFloat(formData.unitPrice),
          wholesalePrice: formData.wholesalePrice ? parseFloat(formData.wholesalePrice) : 0,
          cost: formData.cost ? parseFloat(formData.cost) : 0
        };
      }

      if (editingProduct) {
        await updateDoc(doc(db, 'productItems', editingProduct.id), payload);
        setFormSuccess('Ürün başarıyla güncellendi!');
      } else {
        await addDoc(collection(db, 'productItems'), {
          ...payload,
          createdAt: new Date()
        });
        setFormSuccess('Ürün başarıyla eklendi!');
      }

      await fetchProducts();
      setActiveTypeTab(formData.productType);

      setTimeout(() => {
        setShowForm(false);
        setEditingProduct(null);
        setFormSuccess(null);
      }, 1200);
    } catch (error) {
      console.error('Ürün kaydedilirken hata:', error);
      setFormError('Ürün kaydedilirken bir hata oluştu: ' + error.message);
    } finally {
      setIsSaving(false);
    }
  };

  const handleDelete = async () => {
    if (!deleteModal) return;
    try {
      await deleteDoc(doc(db, 'productItems', deleteModal.id));
      setDeleteModal(null);
      await fetchProducts();
    } catch (error) {
      console.error('Ürün silinirken hata:', error);
    }
  };

  const handleExportExcel = () => {
    if (filteredProducts.length === 0) {
      setExcelModal({ show: true, type: 'info', title: 'Bilgi', message: 'Dışa aktarılacak ürün bulunamadı.' });
      return;
    }

    const isJaluzi = activeTypeTab === 'ahsapJaluzi';

    const exportData = filteredProducts.map(p => {
      if (isJaluzi) {
        return {
          'Ürün Adı': p.name,
          'Merdiven İpli Maliyet': p.merdivenIpliMaliyet || 0,
          'Merdiven İpli': p.merdivenIpliFiyat || 0,
          'Merdiven İpli Toptan': p.merdivenIpliToptan || 0,
          'Kurdeleli Maliyet': p.kurdeleliMaliyet || 0,
          'Kurdeleli': p.kurdeleliFiyat || 0,
          'Kurdeleli Toptan': p.kurdeleliToptan || 0,
          'Merdiven İpli Redüktörlü Maliyet': p.merdivenIpliReduktorluMaliyet || 0,
          'Merdiven İpli Redüktörlü': p.merdivenIpliReduktorluFiyat || 0,
          'Merdiven İpli Redüktörlü Toptan': p.merdivenIpliReduktorluToptan || 0,
          'Kurdelalı Redüktörlü Maliyet': p.kurdelaliReduktorluMaliyet || 0,
          'Kurdelalı Redüktörlü': p.kurdelaliReduktorluFiyat || 0,
          'Kurdelalı Redüktörlü Toptan': p.kurdelaliReduktorluToptan || 0
        };
      } else {
        return {
          'Ürün Adı': p.name,
          'Maliyet': p.cost || 0,
          'Birim Fiyat': p.unitPrice,
          'Toptan Fiyat': p.wholesalePrice || 0
        };
      }
    });

    const worksheet = XLSX.utils.json_to_sheet(exportData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Ürünler');

    const typeLabel = PRODUCT_TYPES[activeTypeTab]?.label || 'Urunler';
    XLSX.writeFile(workbook, `${typeLabel}_Urun_Listesi.xlsx`);
  };

  const handleImportClick = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  const handleClearList = () => {
    const typeLabel = PRODUCT_TYPES[activeTypeTab]?.label;
    const currentCount = products.filter(p => p.productType === activeTypeTab).length;
    if (currentCount === 0) {
      setExcelModal({ show: true, type: 'info', title: 'Bilgi', message: 'Bu kategoride silinecek ürün bulunamadı.' });
      return;
    }
    setExcelModal({
      show: true,
      type: 'confirm',
      title: 'Listeyi Temizle',
      message: `DİKKAT! "${typeLabel}" kategorisindeki ${currentCount} ürünün TAMAMI silinecektir.\n\nBu işlem geri alınamaz. Emin misiniz?`,
      onConfirm: async () => {
        setExcelModal({ show: false });
        setIsExcelLoading(true);
        try {
          const toDelete = products.filter(p => p.productType === activeTypeTab);
          const chunkSize = 400;
          for (let i = 0; i < toDelete.length; i += chunkSize) {
            const chunk = toDelete.slice(i, i + chunkSize);
            const batch = writeBatch(db);
            chunk.forEach(p => batch.delete(doc(db, 'productItems', p.id)));
            await batch.commit();
          }
          setExcelModal({ show: true, type: 'success', title: 'Temizlendi', message: `${toDelete.length} ürün başarıyla silindi.` });
          await fetchProducts();
        } catch (err) {
          setExcelModal({ show: true, type: 'error', title: 'Hata', message: 'Liste temizlenirken bir hata oluştu: ' + err.message });
        } finally {
          setIsExcelLoading(false);
        }
      }
    });
  };

  const processExcelData = async (data, typeLabel) => {
    setExcelModal({ show: false });
    try {
      const isJaluzi = activeTypeTab === 'ahsapJaluzi';
      const existingByName = {};
      products
        .filter(p => p.productType === activeTypeTab)
        .forEach(p => {
          existingByName[(p.name || '').toLowerCase().trim()] = p;
        });

      const chunks = [];
      let currentChunk = [];

      for (const row of data) {
        const name = row['Ürün Adı']?.toString().trim();
        if (!name) continue;

        let payload = {
          name,
          productType: activeTypeTab,
          updatedAt: new Date()
        };

        let isValid = false;

        if (isJaluzi) {
          payload = {
            ...payload,
            merdivenIpliFiyat: parseFloat(row['Merdiven İpli']) || 0,
            merdivenIpliMaliyet: parseFloat(row['Merdiven İpli Maliyet']) || 0,
            merdivenIpliToptan: parseFloat(row['Merdiven İpli Toptan']) || 0,
            kurdeleliFiyat: parseFloat(row['Kurdeleli']) || 0,
            kurdeleliMaliyet: parseFloat(row['Kurdeleli Maliyet']) || 0,
            kurdeleliToptan: parseFloat(row['Kurdeleli Toptan']) || 0,
            merdivenIpliReduktorluFiyat: parseFloat(row['Merdiven İpli Redüktörlü']) || 0,
            merdivenIpliReduktorluMaliyet: parseFloat(row['Merdiven İpli Redüktörlü Maliyet']) || 0,
            merdivenIpliReduktorluToptan: parseFloat(row['Merdiven İpli Redüktörlü Toptan']) || 0,
            kurdelaliReduktorluFiyat: parseFloat(row['Kurdelalı Redüktörlü']) || 0,
            kurdelaliReduktorluMaliyet: parseFloat(row['Kurdelalı Redüktörlü Maliyet']) || 0,
            kurdelaliReduktorluToptan: parseFloat(row['Kurdelalı Redüktörlü Toptan']) || 0
          };
          isValid = true;
        } else {
          const unitPrice = parseFloat(row['Birim Fiyat']);
          const wholesalePrice = parseFloat(row['Toptan Fiyat']);
          const cost = parseFloat(row['Maliyet']);
          if (!isNaN(unitPrice)) {
            payload = {
              ...payload,
              unitPrice,
              wholesalePrice: isNaN(wholesalePrice) ? 0 : wholesalePrice,
              cost: isNaN(cost) ? 0 : cost
            };
            isValid = true;
          }
        }

        if (!isValid) continue;

        const existing = existingByName[name.toLowerCase()];
        currentChunk.push({ existing, payload });

        if (currentChunk.length === 400) {
          chunks.push(currentChunk);
          currentChunk = [];
        }
      }

      if (currentChunk.length > 0) {
        chunks.push(currentChunk);
      }

      let updateCount = 0;
      let addCount = 0;

      for (const chunk of chunks) {
        const batch = writeBatch(db);
        for (const { existing, payload } of chunk) {
          if (existing) {
            batch.update(doc(db, 'productItems', existing.id), payload);
            updateCount++;
          } else {
            const newRef = doc(collection(db, 'productItems'));
            batch.set(newRef, { ...payload, createdAt: new Date() });
            addCount++;
          }
        }
        await batch.commit();
      }

      const msg = [
        updateCount > 0 ? `${updateCount} ürün güncellendi` : null,
        addCount > 0 ? `${addCount} yeni ürün eklendi` : null
      ].filter(Boolean).join(', ');

      setExcelModal({ show: true, type: 'success', title: 'Başarılı', message: msg ? `${msg}.` : 'Değişiklik yapılmadı.' });
      await fetchProducts();
    } catch (error) {
      console.error('Excel içe aktarılırken hata:', error);
      setExcelModal({ show: true, type: 'error', title: 'Hata', message: 'Excel dosyası okunurken bir hata oluştu: ' + error.message });
    } finally {
      setIsExcelLoading(false);
    }
  };

  const handleImportExcel = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    e.target.value = null;
    const reader = new FileReader();
    reader.onload = async (evt) => {
      try {
        setIsExcelLoading(true);
        const bstr = evt.target.result;
        const workbook = XLSX.read(bstr, { type: 'binary' });
        const worksheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[worksheetName];
        const data = XLSX.utils.sheet_to_json(worksheet, { defval: '' });

        if (data.length === 0) {
          setExcelModal({ show: true, type: 'error', title: 'Hata', message: 'Excel dosyası boş veya okunamadı.' });
          setIsExcelLoading(false);
          return;
        }

        const firstRow = data[0];
        const isJaluzi = activeTypeTab === 'ahsapJaluzi';

        if (isJaluzi) {
          if (!('Ürün Adı' in firstRow) || !('Merdiven İpli' in firstRow)) {
            setExcelModal({ show: true, type: 'error', title: 'Hatalı Format', message: `Hatalı Excel formatı! Ahşap/Metal Jaluzi dosyalarında "Ürün Adı", "Merdiven İpli", "Kurdeleli" gibi başlıklar bulunmalıdır.\n\n(Lütfen taslağı görmek için önce "Excel'e Aktar" diyerek örnek dosyayı indirin)` });
            setIsExcelLoading(false);
            return;
          }
        } else {
          if (!('Ürün Adı' in firstRow) || !('Birim Fiyat' in firstRow)) {
            setExcelModal({ show: true, type: 'error', title: 'Hatalı Format', message: `Hatalı Excel formatı! Dosyada "Ürün Adı" ve "Birim Fiyat" başlıkları bulunmalıdır.\n\n(Lütfen taslağı görmek için önce "Excel'e Aktar" diyerek örnek dosyayı indirin)` });
            setIsExcelLoading(false);
            return;
          }
        }

        const typeLabel = PRODUCT_TYPES[activeTypeTab]?.label;
        const existingCount = products.filter(p => p.productType === activeTypeTab).length;
        setExcelModal({
          show: true,
          type: 'confirm',
          title: 'Excel Yükleme Onayı',
          message: `Excel dosyasındaki ${data.length} ürün işlenecek:\n\n• Mevcut ${existingCount} ürün içinden eşleşenler güncellenir\n• Listede olmayan yeni ürünler eklenir\n• Listede olup Excel'de olmayan ürünlere dokunulmaz\n\nOnaylıyor musunuz?`,
          onConfirm: () => processExcelData(data, typeLabel)
        });
      } catch (error) {
        console.error('Excel dosyası parse edilirken hata:', error);
        setExcelModal({ show: true, type: 'error', title: 'Parse Hatası', message: 'Dosya okunurken bir hata oluştu.' });
        setIsExcelLoading(false);
      }
    };
    reader.readAsBinaryString(file);
  };

  return (
    <div className="product-list-page">
      <div className="product-list-header">
        <div className="product-list-title">
          <h2>Ürün Listesi</h2>
          <p>Ürün tipine göre kategorize edilmiş ürün kataloğu</p>
        </div>
      </div>

      <div className="global-topbar">
        <div className="topbar-title">
          <i className="fas fa-coins" style={{ color: '#b04309' }}></i>
          <h4>Döviz Kuru ve Motor Ayarları</h4>
        </div>
        <div className="topbar-exchange-rates">
          <span className="topbar-rate" title="Güncel Dolar Kuru"><i className="fas fa-dollar-sign"></i> <b>{exchangeRates.USD}</b> ₺</span>
          <span className="topbar-rate" title="Güncel Euro Kuru"><i className="fas fa-euro-sign"></i> <b>{exchangeRates.EUR}</b> ₺</span>
        </div>
      </div>

      <div className="product-nav-container">
        {Object.entries(PRODUCT_TYPES)
          .filter(([key]) => {
            if (isMontajci) return key === 'plise';
            return true;
          })
          .map(([key, type]) => {
            const count = productCounts[key] || 0;
            return (
              <button
                key={key}
                className={`nav-pill ${activeTypeTab === key ? 'active' : ''}`}
                onClick={() => handleTabChange(key)}
              >
                <i className={`fas fa-${key === 'tul' ? 'scroll' :
                    key === 'kanat' ? 'border-all' :
                      key === 'ahsapJaluzi' ? 'align-justify' :
                        key === 'metalJaluzi' ? 'th-list' :
                          key === 'stor' ? 'window-maximize' :
                            key === 'zebra' ? 'equals' :
                              key === 'dikeyPerde' ? 'columns' :
                                key === 'plise' ? 'layer-group' :
                                  key === 'raySistemi' ? 'road' :
                                    key === 'rustik' ? 'ellipsis-h' : 'box'
                  }`}></i>
                {type.label}
                <span className={`tab-count ${isLoading ? 'loading' : ''} ${!isLoading && count === 0 ? 'empty' : ''}`}>
                  {isLoading ? '...' : count}
                </span>
              </button>
            );
          })}
      </div>

      <div className="product-table-wrapper">
        <div className="product-table-header-bar">
          <div className="product-table-title">
            <i className="fas fa-list"></i>
            <span>{PRODUCT_TYPES[activeTypeTab]?.label || 'Ürün'} Ürünleri</span>
            <span className="product-count">({filteredProducts.length} ürün)</span>
          </div>
          {(isAdmin || isSatisci) && !isMontajci && (
            <div className="excel-actions">
              <input
                type="file"
                ref={fileInputRef}
                style={{ display: 'none' }}
                accept=".xlsx, .xls, .csv"
                onChange={handleImportExcel}
              />
              <button
                className="btn-excel btn-import"
                onClick={handleImportClick}
                disabled={isExcelLoading}
              >
                {isExcelLoading ? <i className="fas fa-spinner fa-spin"></i> : <i className="fas fa-file-import"></i>} Excel'den Yükle
              </button>
              <button
                className="btn-excel btn-export"
                onClick={handleExportExcel}
                disabled={filteredProducts.length === 0 || isExcelLoading}
              >
                <i className="fas fa-file-export"></i> Excel'e Aktar
              </button>
              <button
                className="btn-excel btn-clear-list"
                onClick={handleClearList}
                disabled={isExcelLoading}
                title="Bu kategorideki tüm ürünleri sil"
              >
                <i className="fas fa-trash-alt"></i> Listeyi Temizle
              </button>
            </div>
          )}
        </div>

        <div className="product-settings-container">
          {activeTypeTab === 'rustik' && (isAdmin || isSatisci) && (
            <div className="settings-card">
              <div
                className="settings-header clickable"
                onClick={() => setIsRustikSettingsCollapsed(!isRustikSettingsCollapsed)}
              >
                <div className="settings-title">
                  <i className="fas fa-ellipsis-h"></i>
                  <span>Rustik Ayak Ücret Ayarları</span>
                </div>
                <i className={`fas fa-chevron-${isRustikSettingsCollapsed ? 'down' : 'up'}`}></i>
              </div>

              {!isRustikSettingsCollapsed && (
                <div className="settings-content">
                  <div className="settings-grid">
                    <div className="settings-column">
                      <div
                        className="settings-sub-header clickable"
                        onClick={() => setIsRustikModelCollapsed(!isRustikModelCollapsed)}
                      >
                        <h4><i className="fas fa-couch"></i> Ayak Model Listesi</h4>
                        <i className={`fas fa-chevron-${isRustikModelCollapsed ? 'down' : 'up'}`}></i>
                      </div>

                      {!isRustikModelCollapsed && (
                        <div className="settings-sub-content">
                          <div className="list-add-form">
                            <input
                              type="text"
                              placeholder="Yeni Model"
                              value={newRustikModel}
                              onChange={(e) => setNewRustikModel(e.target.value)}
                            />
                            <button onClick={() => {
                              if (!newRustikModel) return;
                              const newList = [...rustikExtras.ayakModelList, newRustikModel];
                              setRustikExtras({ ...rustikExtras, ayakModelList: newList });
                              setNewRustikModel('');
                              handleSaveSettings({ rustikAyakModelList: newList });
                            }}><i className="fas fa-plus"></i></button>
                          </div>
                          <div className="settings-list-container">
                            {rustikExtras.ayakModelList.length === 0 && <span className="empty-list-msg">Liste boş</span>}
                            <ul className="settings-inner-list">
                              {rustikExtras.ayakModelList.map((item, index) => (
                                <li key={index} className="settings-list-item">
                                  {editingRustikModel.index === index ? (
                                    <div className="edit-mode-container">
                                      <input
                                        type="text"
                                        value={editingRustikModel.value}
                                        onChange={(e) => setEditingRustikModel({ ...editingRustikModel, value: e.target.value })}
                                        autoFocus
                                      />
                                      <div className="edit-actions">
                                        <button className="btn-confirm" onClick={() => {
                                          const newList = [...rustikExtras.ayakModelList];
                                          newList[index] = editingRustikModel.value;
                                          setRustikExtras({ ...rustikExtras, ayakModelList: newList });
                                          handleSaveSettings({ rustikAyakModelList: newList });
                                          setEditingRustikModel({ index: null, value: '' });
                                        }}><i className="fas fa-check"></i></button>
                                        <button className="btn-cancel" onClick={() => setEditingRustikModel({ index: null, value: '' })}><i className="fas fa-times"></i></button>
                                      </div>
                                    </div>
                                  ) : (
                                    <>
                                      <span className="item-text">{item}</span>
                                      <div className="item-actions">
                                        <button className="btn-edit" onClick={() => setEditingRustikModel({ index, value: item })}><i className="fas fa-edit"></i></button>
                                        <button className="btn-delete" onClick={() => {
                                          const newList = rustikExtras.ayakModelList.filter((_, i) => i !== index);
                                          setRustikExtras({ ...rustikExtras, ayakModelList: newList });
                                          handleSaveSettings({ rustikAyakModelList: newList });
                                        }}><i className="fas fa-trash-alt"></i></button>
                                      </div>
                                    </>
                                  )}
                                </li>
                              ))}
                            </ul>
                          </div>
                        </div>
                      )}
                    </div>

                    <div className="settings-column">
                      <div
                        className="settings-sub-header clickable"
                        onClick={() => setIsRustikCapCollapsed(!isRustikCapCollapsed)}
                      >
                        <h4><i className="fas fa-ruler-combined"></i> Ayak Çap Listesi</h4>
                        <i className={`fas fa-chevron-${isRustikCapCollapsed ? 'down' : 'up'}`}></i>
                      </div>

                      {!isRustikCapCollapsed && (
                        <div className="settings-sub-content">
                          <div className="list-add-form">
                            <input
                              type="text"
                              placeholder="Yeni Çap"
                              value={newRustikCap}
                              onChange={(e) => setNewRustikCap(e.target.value)}
                            />
                            <button onClick={() => {
                              if (!newRustikCap) return;
                              const newList = [...rustikExtras.ayakCapList, newRustikCap];
                              setRustikExtras({ ...rustikExtras, ayakCapList: newList });
                              setNewRustikCap('');
                              handleSaveSettings({ rustikAyakCapList: newList });
                            }}><i className="fas fa-plus"></i></button>
                          </div>
                          <div className="settings-list-container">
                            {rustikExtras.ayakCapList.length === 0 && <span className="empty-list-msg">Liste boş</span>}
                            <ul className="settings-inner-list">
                              {rustikExtras.ayakCapList.map((item, index) => (
                                <li key={index} className="settings-list-item">
                                  {editingRustikCap.index === index ? (
                                    <div className="edit-mode-container">
                                      <input
                                        type="text"
                                        value={editingRustikCap.value}
                                        onChange={(e) => setEditingRustikCap({ ...editingRustikCap, value: e.target.value })}
                                        autoFocus
                                      />
                                      <div className="edit-actions">
                                        <button className="btn-confirm" onClick={() => {
                                          const newList = [...rustikExtras.ayakCapList];
                                          newList[index] = editingRustikCap.value;
                                          setRustikExtras({ ...rustikExtras, ayakCapList: newList });
                                          handleSaveSettings({ rustikAyakCapList: newList });
                                          setEditingRustikCap({ index: null, value: '' });
                                        }}><i className="fas fa-check"></i></button>
                                        <button className="btn-cancel" onClick={() => setEditingRustikCap({ index: null, value: '' })}><i className="fas fa-times"></i></button>
                                      </div>
                                    </div>
                                  ) : (
                                    <>
                                      <span className="item-text">{item}</span>
                                      <div className="item-actions">
                                        <button className="btn-edit" onClick={() => setEditingRustikCap({ index, value: item })}><i className="fas fa-edit"></i></button>
                                        <button className="btn-delete" onClick={() => {
                                          const newList = rustikExtras.ayakCapList.filter((_, i) => i !== index);
                                          setRustikExtras({ ...rustikExtras, ayakCapList: newList });
                                          handleSaveSettings({ rustikAyakCapList: newList });
                                        }}><i className="fas fa-trash-alt"></i></button>
                                      </div>
                                    </>
                                  )}
                                </li>
                              ))}
                            </ul>
                          </div>
                        </div>
                      )}
                    </div>

                    <div className="settings-column">
                      <div
                        className="settings-sub-header clickable"
                        onClick={() => setIsRustikUzunlukCollapsed(!isRustikUzunlukCollapsed)}
                      >
                        <h4><i className="fas fa-arrows-alt-v"></i> Ayak Uzunluğu</h4>
                        <i className={`fas fa-chevron-${isRustikUzunlukCollapsed ? 'down' : 'up'}`}></i>
                      </div>

                      {!isRustikUzunlukCollapsed && (
                        <div className="settings-sub-content">
                          <div className="list-add-form">
                            <input
                              type="text"
                              placeholder="Yeni Uzunluk"
                              value={newRustikUzunluk}
                              onChange={(e) => setNewRustikUzunluk(e.target.value)}
                            />
                            <button onClick={() => {
                              if (!newRustikUzunluk) return;
                              const newList = [...rustikExtras.ayakUzunlukList, newRustikUzunluk];
                              setRustikExtras({ ...rustikExtras, ayakUzunlukList: newList });
                              setNewRustikUzunluk('');
                              handleSaveSettings({ rustikAyakUzunlukList: newList });
                            }}><i className="fas fa-plus"></i></button>
                          </div>
                          <div className="settings-list-container">
                            {rustikExtras.ayakUzunlukList.length === 0 && <span className="empty-list-msg">Liste boş</span>}
                            <ul className="settings-inner-list">
                              {rustikExtras.ayakUzunlukList.map((item, index) => (
                                <li key={index} className="settings-list-item">
                                  {editingRustikUzunluk.index === index ? (
                                    <div className="edit-mode-container">
                                      <input
                                        type="text"
                                        value={editingRustikUzunluk.value}
                                        onChange={(e) => setEditingRustikUzunluk({ ...editingRustikUzunluk, value: e.target.value })}
                                        autoFocus
                                      />
                                      <div className="edit-actions">
                                        <button className="btn-confirm" onClick={() => {
                                          const newList = [...rustikExtras.ayakUzunlukList];
                                          newList[index] = editingRustikUzunluk.value;
                                          setRustikExtras({ ...rustikExtras, ayakUzunlukList: newList });
                                          handleSaveSettings({ rustikAyakUzunlukList: newList });
                                          setEditingRustikUzunluk({ index: null, value: '' });
                                        }}><i className="fas fa-check"></i></button>
                                        <button className="btn-cancel" onClick={() => setEditingRustikUzunluk({ index: null, value: '' })}><i className="fas fa-times"></i></button>
                                      </div>
                                    </div>
                                  ) : (
                                    <>
                                      <span className="item-text">{item}</span>
                                      <div className="item-actions">
                                        <button className="btn-edit" onClick={() => setEditingRustikUzunluk({ index, value: item })}><i className="fas fa-edit"></i></button>
                                        <button className="btn-delete" onClick={() => {
                                          const newList = rustikExtras.ayakUzunlukList.filter((_, i) => i !== index);
                                          setRustikExtras({ ...rustikExtras, ayakUzunlukList: newList });
                                          handleSaveSettings({ rustikAyakUzunlukList: newList });
                                        }}><i className="fas fa-trash-alt"></i></button>
                                      </div>
                                    </>
                                  )}
                                </li>
                              ))}
                            </ul>
                          </div>
                        </div>
                      )}
                    </div>

                    <div className="settings-column">
                      <div
                        className="settings-sub-header clickable"
                        onClick={() => setIsRustikRenkCollapsed(!isRustikRenkCollapsed)}
                      >
                        <h4><i className="fas fa-palette"></i> Renk Kodu Listesi</h4>
                        <i className={`fas fa-chevron-${isRustikRenkCollapsed ? 'down' : 'up'}`}></i>
                      </div>

                      {!isRustikRenkCollapsed && (
                        <div className="settings-sub-content">
                          <div className="list-add-form">
                            <input
                              type="text"
                              placeholder="Yeni Renk"
                              value={newRustikRenk}
                              onChange={(e) => setNewRustikRenk(e.target.value)}
                            />
                            <button onClick={() => {
                              if (!newRustikRenk) return;
                              const newList = [...rustikExtras.ayakRenkKoduList, newRustikRenk];
                              setRustikExtras({ ...rustikExtras, ayakRenkKoduList: newList });
                              setNewRustikRenk('');
                              handleSaveSettings({ rustikAyakRenkKoduList: newList });
                            }}><i className="fas fa-plus"></i></button>
                          </div>
                          <div className="settings-list-container">
                            {rustikExtras.ayakRenkKoduList.length === 0 && <span className="empty-list-msg">Liste boş</span>}
                            <ul className="settings-inner-list">
                              {rustikExtras.ayakRenkKoduList.map((item, index) => (
                                <li key={index} className="settings-list-item">
                                  {editingRustikRenk.index === index ? (
                                    <div className="edit-mode-container">
                                      <input
                                        type="text"
                                        value={editingRustikRenk.value}
                                        onChange={(e) => setEditingRustikRenk({ ...editingRustikRenk, value: e.target.value })}
                                        autoFocus
                                      />
                                      <div className="edit-actions">
                                        <button className="btn-confirm" onClick={() => {
                                          const newList = [...rustikExtras.ayakRenkKoduList];
                                          newList[index] = editingRustikRenk.value;
                                          setRustikExtras({ ...rustikExtras, ayakRenkKoduList: newList });
                                          handleSaveSettings({ rustikAyakRenkKoduList: newList });
                                          setEditingRustikRenk({ index: null, value: '' });
                                        }}><i className="fas fa-check"></i></button>
                                        <button className="btn-cancel" onClick={() => setEditingRustikRenk({ index: null, value: '' })}><i className="fas fa-times"></i></button>
                                      </div>
                                    </div>
                                  ) : (
                                    <>
                                      <span className="item-text">{item}</span>
                                      <div className="item-actions">
                                        <button className="btn-edit" onClick={() => setEditingRustikRenk({ index, value: item })}><i className="fas fa-edit"></i></button>
                                        <button className="btn-delete" onClick={() => {
                                          const newList = rustikExtras.ayakRenkKoduList.filter((_, i) => i !== index);
                                          setRustikExtras({ ...rustikExtras, ayakRenkKoduList: newList });
                                          handleSaveSettings({ rustikAyakRenkKoduList: newList });
                                        }}><i className="fas fa-trash-alt"></i></button>
                                      </div>
                                    </>
                                  )}
                                </li>
                              ))}
                            </ul>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              )}
            </div>
          )}

          {/* Diğer Ürün Tiplerinin Ayarları */}
          {activeTypeTab === 'tul' && (
            <PileSettingsPanel
              title="Tül Pile Ek Ücret Ayarları (₺)"
              extraPrices={extraPrices}
              setExtraPrices={setExtraPrices}
              isSavingSettings={isSavingSettings}
              handleSaveSettings={handleSaveSettings}
            />
          )}

          {activeTypeTab === 'kanat' && (
            <PileSettingsPanel
              title="Kanat Pile Ek Ücret Ayarları (₺)"
              extraPrices={kanatExtraPrices}
              setExtraPrices={setKanatExtraPrices}
              isSavingSettings={isSavingSettings}
              handleSaveSettings={handleSaveSettings}
            />
          )}

          {activeTypeTab === 'ahsapJaluzi' && (
            <>
              <div className="settings-panel">
                <div className="settings-panel-header">
                  <i className="fas fa-layer-group"></i>
                  <h4>Ahşap Jaluzi Ek Ücret Ayarları (₺)</h4>
                </div>
                <div className="settings-grid">
                  <div className="price-group-wrapper">
                    <span className="price-group-name"><i className="fas fa-link" style={{ fontSize: '0.8rem' }}></i>Zıgıl Sistem</span>
                    <div className="price-group-grid">
                      <div className="price-field"><label>Maliyet</label><input type="number" className="modern-settings-input" value={ahsapJaluziExtras.zigil.cost} onChange={(e) => setAhsapJaluziExtras(p => ({ ...p, zigil: { ...p.zigil, cost: e.target.value } }))} /></div>
                      <div className="price-field"><label>Perakende</label><input type="number" className="modern-settings-input" value={ahsapJaluziExtras.zigil.retail} onChange={(e) => setAhsapJaluziExtras(p => ({ ...p, zigil: { ...p.zigil, retail: e.target.value } }))} /></div>
                      <div className="price-field"><label>Toptan</label><input type="number" className="modern-settings-input" value={ahsapJaluziExtras.zigil.wholesale} onChange={(e) => setAhsapJaluziExtras(p => ({ ...p, zigil: { ...p.zigil, wholesale: e.target.value } }))} /></div>
                    </div>
                  </div>
                  <button className="btn-save" onClick={() => handleSaveSettings()} disabled={isSavingSettings} style={{ borderRadius: '10px' }}>
                    {isSavingSettings ? '...' : 'Kaydet'}
                  </button>
                </div>
              </div>
              {renderMotorSettings('ahsapJaluzi')}
            </>
          )}

          {activeTypeTab === 'metalJaluzi' && (
            <>
              <div className="settings-panel">
                <div className="settings-panel-header">
                  <i className="fas fa-layer-group"></i>
                  <h4>Metal Jaluzi Ek Ücret Ayarları (₺)</h4>
                </div>
                <div className="settings-grid">
                  <div className="price-group-wrapper">
                    <span className="price-group-name"><i className="fas fa-link" style={{ fontSize: '0.8rem' }}></i>Zıgıl Sistem</span>
                    <div className="price-group-grid">
                      <div className="price-field"><label>Maliyet</label><input type="number" className="modern-settings-input" value={metalJaluziExtras.zigil.cost} onChange={(e) => setMetalJaluziExtras(p => ({ ...p, zigil: { ...p.zigil, cost: e.target.value } }))} /></div>
                      <div className="price-field"><label>Perakende</label><input type="number" className="modern-settings-input" value={metalJaluziExtras.zigil.retail} onChange={(e) => setMetalJaluziExtras(p => ({ ...p, zigil: { ...p.zigil, retail: e.target.value } }))} /></div>
                      <div className="price-field"><label>Toptan</label><input type="number" className="modern-settings-input" value={metalJaluziExtras.zigil.wholesale} onChange={(e) => setMetalJaluziExtras(p => ({ ...p, zigil: { ...p.zigil, wholesale: e.target.value } }))} /></div>
                    </div>
                  </div>
                  <div className="price-group-wrapper">
                    <span className="price-group-name"><i className="fas fa-cog" style={{ fontSize: '0.8rem' }}></i>Redüktörlü Farkı</span>
                    <div className="price-group-grid">
                      <div className="price-field"><label>Maliyet</label><input type="number" className="modern-settings-input" value={metalJaluziExtras.reduktor.cost} onChange={(e) => setMetalJaluziExtras(p => ({ ...p, reduktor: { ...p.reduktor, cost: e.target.value } }))} /></div>
                      <div className="price-field"><label>Perakende</label><input type="number" className="modern-settings-input" value={metalJaluziExtras.reduktor.retail} onChange={(e) => setMetalJaluziExtras(p => ({ ...p, reduktor: { ...p.reduktor, retail: e.target.value } }))} /></div>
                      <div className="price-field"><label>Toptan</label><input type="number" className="modern-settings-input" value={metalJaluziExtras.reduktor.wholesale} onChange={(e) => setMetalJaluziExtras(p => ({ ...p, reduktor: { ...p.reduktor, wholesale: e.target.value } }))} /></div>
                    </div>
                  </div>
                  <div className="price-group-wrapper">
                    <span className="price-group-name"><i className="fas fa-window-restore" style={{ fontSize: '0.8rem' }}></i>İki Cam Arası</span>
                    <div className="price-group-grid">
                      <div className="price-field"><label>Maliyet</label><input type="number" className="modern-settings-input" value={metalJaluziExtras.ikiCamArasi.cost} onChange={(e) => setMetalJaluziExtras(p => ({ ...p, ikiCamArasi: { ...p.ikiCamArasi, cost: e.target.value } }))} /></div>
                      <div className="price-field"><label>Perakende</label><input type="number" className="modern-settings-input" value={metalJaluziExtras.ikiCamArasi.retail} onChange={(e) => setMetalJaluziExtras(p => ({ ...p, ikiCamArasi: { ...p.ikiCamArasi, retail: e.target.value } }))} /></div>
                      <div className="price-field"><label>Toptan</label><input type="number" className="modern-settings-input" value={metalJaluziExtras.ikiCamArasi.wholesale} onChange={(e) => setMetalJaluziExtras(p => ({ ...p, ikiCamArasi: { ...p.ikiCamArasi, wholesale: e.target.value } }))} /></div>
                    </div>
                  </div>
                  <button className="btn-save" onClick={() => handleSaveSettings()} disabled={isSavingSettings} style={{ borderRadius: '10px' }}>
                    {isSavingSettings ? '...' : 'Kaydet'}
                  </button>
                </div>
              </div>
              {renderMotorSettings('metalJaluzi')}
            </>
          )}

          {activeTypeTab === 'stor' && (
            <>
              <div className="settings-panel">
                <div className="settings-panel-header">
                  <i className="fas fa-cog"></i>
                  <h4>Stor Perde Ücret Ayarları (₺)</h4>
                </div>
                <div className="settings-grid">
                  <div className="price-group-wrapper">
                    <span className="price-group-name"><i className="fas fa-expand" style={{ fontSize: '0.8rem' }}></i>Jumbo Sistem</span>
                    <div className="price-group-grid">
                      <div className="price-field"><label>Maliyet</label><input type="number" className="modern-settings-input" value={storExtras.jumbo.cost} onChange={(e) => setStorExtras(p => ({ ...p, jumbo: { ...p.jumbo, cost: e.target.value } }))} /></div>
                      <div className="price-field"><label>Perakende</label><input type="number" className="modern-settings-input" value={storExtras.jumbo.retail} onChange={(e) => setStorExtras(p => ({ ...p, jumbo: { ...p.jumbo, retail: e.target.value } }))} /></div>
                      <div className="price-field"><label>Toptan</label><input type="number" className="modern-settings-input" value={storExtras.jumbo.wholesale} onChange={(e) => setStorExtras(p => ({ ...p, jumbo: { ...p.jumbo, wholesale: e.target.value } }))} /></div>
                    </div>
                  </div>
                  <div className="price-group-wrapper">
                    <span className="price-group-name"><i className="fas fa-cut" style={{ fontSize: '0.8rem' }}></i>Alt Etek Dilim</span>
                    <div className="price-group-grid">
                      <div className="price-field"><label>Maliyet</label><input type="number" className="modern-settings-input" value={storExtras.altEtekDilim.cost} onChange={(e) => setStorExtras(p => ({ ...p, altEtekDilim: { ...p.altEtekDilim, cost: e.target.value } }))} /></div>
                      <div className="price-field"><label>Perakende</label><input type="number" className="modern-settings-input" value={storExtras.altEtekDilim.retail} onChange={(e) => setStorExtras(p => ({ ...p, altEtekDilim: { ...p.altEtekDilim, retail: e.target.value } }))} /></div>
                      <div className="price-field"><label>Toptan</label><input type="number" className="modern-settings-input" value={storExtras.altEtekDilim.wholesale} onChange={(e) => setStorExtras(p => ({ ...p, altEtekDilim: { ...p.altEtekDilim, wholesale: e.target.value } }))} /></div>
                    </div>
                  </div>
                  <div className="price-group-wrapper">
                    <span className="price-group-name"><i className="fas fa-box" style={{ fontSize: '0.8rem' }}></i>Kapalı Kasa</span>
                    <div className="price-group-grid">
                      <div className="price-field"><label>Maliyet</label><input type="number" className="modern-settings-input" value={storExtras.kapaliKasa.cost} onChange={(e) => setStorExtras(p => ({ ...p, kapaliKasa: { ...p.kapaliKasa, cost: e.target.value } }))} /></div>
                      <div className="price-field"><label>Perakende</label><input type="number" className="modern-settings-input" value={storExtras.kapaliKasa.retail} onChange={(e) => setStorExtras(p => ({ ...p, kapaliKasa: { ...p.kapaliKasa, retail: e.target.value } }))} /></div>
                      <div className="price-field"><label>Toptan</label><input type="number" className="modern-settings-input" value={storExtras.kapaliKasa.wholesale} onChange={(e) => setStorExtras(p => ({ ...p, kapaliKasa: { ...p.kapaliKasa, wholesale: e.target.value } }))} /></div>
                    </div>
                  </div>
                  <div className="price-group-wrapper">
                    <span className="price-group-name"><i className="fas fa-magic" style={{ fontSize: '0.8rem' }}></i>Alt Etek Lazer</span>
                    <div className="price-group-grid">
                      <div className="price-field"><label>Maliyet</label><input type="number" className="modern-settings-input" value={storExtras.altEtekLazer.cost} onChange={(e) => setStorExtras(p => ({ ...p, altEtekLazer: { ...p.altEtekLazer, cost: e.target.value } }))} /></div>
                      <div className="price-field"><label>Perakende</label><input type="number" className="modern-settings-input" value={storExtras.altEtekLazer.retail} onChange={(e) => setStorExtras(p => ({ ...p, altEtekLazer: { ...p.altEtekLazer, retail: e.target.value } }))} /></div>
                      <div className="price-field"><label>Toptan</label><input type="number" className="modern-settings-input" value={storExtras.altEtekLazer.wholesale} onChange={(e) => setStorExtras(p => ({ ...p, altEtekLazer: { ...p.altEtekLazer, wholesale: e.target.value } }))} /></div>
                    </div>
                  </div>
                  <div className="price-group-wrapper">
                    <span className="price-group-name"><i className="fas fa-border-style" style={{ fontSize: '0.8rem' }}></i>Dekoratif Lama</span>
                    <div className="price-group-grid">
                      <div className="price-field"><label>Maliyet</label><input type="number" className="modern-settings-input" value={storExtras.dekoratifLama.cost} onChange={(e) => setStorExtras(p => ({ ...p, dekoratifLama: { ...p.dekoratifLama, cost: e.target.value } }))} /></div>
                      <div className="price-field"><label>Perakende</label><input type="number" className="modern-settings-input" value={storExtras.dekoratifLama.retail} onChange={(e) => setStorExtras(p => ({ ...p, dekoratifLama: { ...p.dekoratifLama, retail: e.target.value } }))} /></div>
                      <div className="price-field"><label>Toptan</label><input type="number" className="modern-settings-input" value={storExtras.dekoratifLama.wholesale} onChange={(e) => setStorExtras(p => ({ ...p, dekoratifLama: { ...p.dekoratifLama, wholesale: e.target.value } }))} /></div>
                    </div>
                  </div>
                  <div className="price-group-wrapper">
                    <span className="price-group-name"><i className="fas fa-vector-square" style={{ fontSize: '0.8rem' }}></i>Dekoratif Kasa</span>
                    <div className="price-group-grid">
                      <div className="price-field"><label>Maliyet</label><input type="number" className="modern-settings-input" value={storExtras.dekoratifKasa.cost} onChange={(e) => setStorExtras(p => ({ ...p, dekoratifKasa: { ...p.dekoratifKasa, cost: e.target.value } }))} /></div>
                      <div className="price-field"><label>Perakende</label><input type="number" className="modern-settings-input" value={storExtras.dekoratifKasa.retail} onChange={(e) => setStorExtras(p => ({ ...p, dekoratifKasa: { ...p.dekoratifKasa, retail: e.target.value } }))} /></div>
                      <div className="price-field"><label>Toptan</label><input type="number" className="modern-settings-input" value={storExtras.dekoratifKasa.wholesale} onChange={(e) => setStorExtras(p => ({ ...p, dekoratifKasa: { ...p.dekoratifKasa, wholesale: e.target.value } }))} /></div>
                    </div>
                  </div>
                  <div className="price-group-wrapper">
                    <span className="price-group-name"><i className="fas fa-brush" style={{ fontSize: '0.8rem' }}></i>Alt Etek Beyaz İş</span>
                    <div className="price-group-grid">
                      <div className="price-field"><label>Maliyet</label><input type="number" className="modern-settings-input" value={storExtras.altEtekBeyazIs.cost} onChange={(e) => setStorExtras(p => ({ ...p, altEtekBeyazIs: { ...p.altEtekBeyazIs, cost: e.target.value } }))} /></div>
                      <div className="price-field"><label>Perakende</label><input type="number" className="modern-settings-input" value={storExtras.altEtekBeyazIs.retail} onChange={(e) => setStorExtras(p => ({ ...p, altEtekBeyazIs: { ...p.altEtekBeyazIs, retail: e.target.value } }))} /></div>
                      <div className="price-field"><label>Toptan</label><input type="number" className="modern-settings-input" value={storExtras.altEtekBeyazIs.wholesale} onChange={(e) => setStorExtras(p => ({ ...p, altEtekBeyazIs: { ...p.altEtekBeyazIs, wholesale: e.target.value } }))} /></div>
                    </div>
                  </div>
                  <button className="btn-save" onClick={() => handleSaveSettings()} disabled={isSavingSettings} style={{ borderRadius: '10px' }}>
                    {isSavingSettings ? '...' : 'Kaydet'}
                  </button>
                </div>
              </div>
              {renderMotorSettings('stor')}
            </>
          )}

          {activeTypeTab === 'zebra' && (
            <>
              <div className="settings-panel">
                <div className="settings-panel-header">
                  <i className="fas fa-stream"></i>
                  <h4>Zebra Perde Ücret Ayarları (₺)</h4>
                </div>
                <div className="settings-grid">
                  <div className="price-group-wrapper">
                    <span className="price-group-name"><i className="fas fa-expand" style={{ fontSize: '0.8rem' }}></i>Jumbo Sistem</span>
                    <div className="price-group-grid">
                      <div className="price-field"><label>Maliyet</label><input type="number" className="modern-settings-input" value={zebraExtras.jumbo.cost} onChange={(e) => setZebraExtras(p => ({ ...p, jumbo: { ...p.jumbo, cost: e.target.value } }))} /></div>
                      <div className="price-field"><label>Perakende</label><input type="number" className="modern-settings-input" value={zebraExtras.jumbo.retail} onChange={(e) => setZebraExtras(p => ({ ...p, jumbo: { ...p.jumbo, retail: e.target.value } }))} /></div>
                      <div className="price-field"><label>Toptan</label><input type="number" className="modern-settings-input" value={zebraExtras.jumbo.wholesale} onChange={(e) => setZebraExtras(p => ({ ...p, jumbo: { ...p.jumbo, wholesale: e.target.value } }))} /></div>
                    </div>
                  </div>
                  <div className="price-group-wrapper">
                    <span className="price-group-name"><i className="fas fa-cut" style={{ fontSize: '0.8rem' }}></i>Alt Etek Dilim</span>
                    <div className="price-group-grid">
                      <div className="price-field"><label>Maliyet</label><input type="number" className="modern-settings-input" value={zebraExtras.altEtekDilim.cost} onChange={(e) => setZebraExtras(p => ({ ...p, altEtekDilim: { ...p.altEtekDilim, cost: e.target.value } }))} /></div>
                      <div className="price-field"><label>Perakende</label><input type="number" className="modern-settings-input" value={zebraExtras.altEtekDilim.retail} onChange={(e) => setZebraExtras(p => ({ ...p, altEtekDilim: { ...p.altEtekDilim, retail: e.target.value } }))} /></div>
                      <div className="price-field"><label>Toptan</label><input type="number" className="modern-settings-input" value={zebraExtras.altEtekDilim.wholesale} onChange={(e) => setZebraExtras(p => ({ ...p, altEtekDilim: { ...p.altEtekDilim, wholesale: e.target.value } }))} /></div>
                    </div>
                  </div>
                  <div className="price-group-wrapper">
                    <span className="price-group-name"><i className="fas fa-box" style={{ fontSize: '0.8rem' }}></i>Kapalı Kasa</span>
                    <div className="price-group-grid">
                      <div className="price-field"><label>Maliyet</label><input type="number" className="modern-settings-input" value={zebraExtras.kapaliKasa.cost} onChange={(e) => setZebraExtras(p => ({ ...p, kapaliKasa: { ...p.kapaliKasa, cost: e.target.value } }))} /></div>
                      <div className="price-field"><label>Perakende</label><input type="number" className="modern-settings-input" value={zebraExtras.kapaliKasa.retail} onChange={(e) => setZebraExtras(p => ({ ...p, kapaliKasa: { ...p.kapaliKasa, retail: e.target.value } }))} /></div>
                      <div className="price-field"><label>Toptan</label><input type="number" className="modern-settings-input" value={zebraExtras.kapaliKasa.wholesale} onChange={(e) => setZebraExtras(p => ({ ...p, kapaliKasa: { ...p.kapaliKasa, wholesale: e.target.value } }))} /></div>
                    </div>
                  </div>
                  <button className="btn-save" onClick={() => handleSaveSettings()} disabled={isSavingSettings} style={{ borderRadius: '10px' }}>
                    {isSavingSettings ? '...' : 'Kaydet'}
                  </button>
                </div>
              </div>
              {renderMotorSettings('zebra')}
            </>
          )}

          {activeTypeTab === 'dikeyPerde' && (
            <>
              <div className="settings-panel">
                <div className="settings-panel-header">
                  <i className="fas fa-arrows-alt-v"></i>
                  <h4>Dikey Perde Fon Ayarları (₺)</h4>
                </div>
                <div className="settings-grid">
                  <div className="price-group-wrapper">
                    <span className="price-group-name"><i className="fas fa-arrows-alt-v" style={{ fontSize: '0.8rem' }}></i>Dikey Perde Fon Ücreti (m2)</span>
                    <div className="price-group-grid">
                      <div className="price-field"><label>Maliyet</label><input type="number" className="modern-settings-input" value={dikeyExtras.fon.cost} onChange={(e) => setDikeyExtras(p => ({ ...p, fon: { ...p.fon, cost: e.target.value } }))} /></div>
                      <div className="price-field"><label>Perakende</label><input type="number" className="modern-settings-input" value={dikeyExtras.fon.retail} onChange={(e) => setDikeyExtras(p => ({ ...p, fon: { ...p.fon, retail: e.target.value } }))} /></div>
                      <div className="price-field"><label>Toptan</label><input type="number" className="modern-settings-input" value={dikeyExtras.fon.wholesale} onChange={(e) => setDikeyExtras(p => ({ ...p, fon: { ...p.fon, wholesale: e.target.value } }))} /></div>
                    </div>
                  </div>
                  <button className="btn-save" onClick={() => handleSaveSettings()} disabled={isSavingSettings} style={{ borderRadius: '10px' }}>
                    {isSavingSettings ? '...' : 'Kaydet'}
                  </button>
                </div>
              </div>
              {renderMotorSettings('dikeyPerde')}
            </>
          )}

          {activeTypeTab === 'dikeyPvc' && renderMotorSettings('dikeyPvc')}
          {activeTypeTab === 'dikeyStor' && renderMotorSettings('dikeyStor')}

          {activeTypeTab === 'katlamaliPerde' && (
            <>
              <div className="settings-panel">
                <div className="settings-panel-header">
                  <i className="fas fa-tools"></i>
                  <h4>Katlamalı Perde Mekanizma Ayarları</h4>
                </div>
                <div className="settings-grid">
                  <div style={{ width: '100%' }}>
                    <div
                      onClick={() => setIsKatlamaliMekanizmaCollapsed(!isKatlamaliMekanizmaCollapsed)}
                      style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', cursor: 'pointer', marginBottom: '10px' }}
                    >
                      <h4 style={{ margin: 0, fontSize: '14px', color: '#334155', fontWeight: '600' }}>Mekanizma Tipleri ve Ücretleri</h4>
                      <i className={`fas fa-chevron-${isKatlamaliMekanizmaCollapsed ? 'down' : 'up'}`} style={{ color: '#64748b', fontSize: '12px' }}></i>
                    </div>

                    {!isKatlamaliMekanizmaCollapsed && (
                      <div className="mekanizma-list-content">
                        <div style={{ display: 'flex', gap: '10px', marginBottom: '15px', width: '100%', flexWrap: 'wrap' }}>
                          <input type="text" placeholder="Mekanizma Tipi" className="modern-settings-input" value={newKatlamaliMekanizma.type} onChange={(e) => setNewKatlamaliMekanizma({ ...newKatlamaliMekanizma, type: e.target.value })} style={{ flex: 2, minWidth: '150px' }} />
                          <input type="number" placeholder="Maliyet" className="modern-settings-input" value={newKatlamaliMekanizma.cost} onChange={(e) => setNewKatlamaliMekanizma({ ...newKatlamaliMekanizma, cost: e.target.value })} style={{ flex: 1, minWidth: '80px' }} />
                          <input type="number" placeholder="Per." className="modern-settings-input" value={newKatlamaliMekanizma.price} onChange={(e) => setNewKatlamaliMekanizma({ ...newKatlamaliMekanizma, price: e.target.value })} style={{ flex: 1, minWidth: '80px' }} />
                          <input type="number" placeholder="Top." className="modern-settings-input" value={newKatlamaliMekanizma.wholesale} onChange={(e) => setNewKatlamaliMekanizma({ ...newKatlamaliMekanizma, wholesale: e.target.value })} style={{ flex: 1, minWidth: '80px' }} />
                          <button
                            onClick={() => {
                              if (!newKatlamaliMekanizma.type.trim()) return;
                              const currentList = katlamaliExtras.mekanizmaList || [];
                              const newList = [...currentList, {
                                id: Date.now().toString(),
                                type: newKatlamaliMekanizma.type.trim(),
                                cost: parseFloat(newKatlamaliMekanizma.cost) || 0,
                                price: parseFloat(newKatlamaliMekanizma.price) || 0,
                                wholesale: parseFloat(newKatlamaliMekanizma.wholesale) || 0
                              }];
                              setKatlamaliExtras({ ...katlamaliExtras, mekanizmaList: newList });
                              handleSaveSettings({ katlamaliMekanizmaList: newList });
                              setNewKatlamaliMekanizma({ type: '', cost: '', price: '', wholesale: '' });
                            }}
                            className="btn-save"
                            style={{ height: '38px' }}
                          >
                            Ekle
                          </button>
                        </div>

                        {katlamaliExtras.mekanizmaList && katlamaliExtras.mekanizmaList.length > 0 ? (
                          <ul style={{ listStyle: 'none', padding: 0, margin: 0, border: '1px solid #e2e8f0', borderRadius: '8px', backgroundColor: 'white' }}>
                            {katlamaliExtras.mekanizmaList.map((mek, idx) => (
                              <li key={mek.id} style={{ display: 'flex', flexDirection: 'column', padding: '10px 12px', borderBottom: idx < katlamaliExtras.mekanizmaList.length - 1 ? '1px solid #e2e8f0' : 'none' }}>
                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                  <span style={{ fontSize: '14px', fontWeight: '500', color: '#1e293b' }}>{mek.type}</span>
                                  <button onClick={() => {
                                    const newList = katlamaliExtras.mekanizmaList.filter(m => m.id !== mek.id);
                                    setKatlamaliExtras({ ...katlamaliExtras, mekanizmaList: newList });
                                    handleSaveSettings({ katlamaliMekanizmaList: newList });
                                  }} style={{ background: 'none', border: 'none', color: '#ef4444', cursor: 'pointer' }}><i className="fas fa-trash"></i></button>
                                </div>
                                <div style={{ display: 'flex', gap: '15px' }}>
                                  <small>Mal: {formatPrice(mek.cost)} ₺</small>
                                  <small>Per: {formatPrice(mek.price)} ₺</small>
                                  <small>Top: {formatPrice(mek.wholesale)} ₺</small>
                                </div>
                              </li>
                            ))}
                          </ul>
                        ) : (
                          <p style={{ fontSize: '13px', color: '#64748b' }}>Henüz mekanizma eklenmemiş.</p>
                        )}
                      </div>
                    )}
                  </div>
                  <button className="btn-save" onClick={() => handleSaveSettings()} disabled={isSavingSettings} style={{ borderRadius: '10px', marginTop: '15px' }}>
                    {isSavingSettings ? '...' : 'Kaydet'}
                  </button>
                </div>
              </div>
              {renderMotorSettings('katlamaliPerde')}
            </>
          )}
        </div>

        {/* Arama Kutusu */}
        <div className="product-search-bar">
          <div className="product-search-input-wrapper">
            <i className="fas fa-search product-search-icon"></i>
            <input
              type="text"
              className="product-search-input"
              placeholder="Ürün adıyla ara..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
            {searchQuery && (
              <button
                className="product-search-clear"
                onClick={() => setSearchQuery('')}
                title="Aramayı temizle"
              >
                <i className="fas fa-times"></i>
              </button>
            )}
          </div>
          {searchQuery && (
            <span className="product-search-result-count">
              {filteredProducts.length} sonuç bulundu
            </span>
          )}

          <div className="product-search-actions">
            {(isAdmin || isSatisci) && !isMontajci && (
              <button className="btn-add-product" onClick={handleAddNew}>
                <i className="fas fa-plus"></i> Yeni Ürün Ekle
              </button>
            )}
          </div>
        </div>

        {isLoading ? (
          <div className="product-loading">
            <i className="fas fa-spinner fa-spin"></i> Yükleniyor...
          </div>
        ) : filteredProducts.length === 0 ? (
          <div className="product-empty-state">
            <div className="product-empty-icon">
              <i className="fas fa-box-open"></i>
            </div>
            <h3 className="product-empty-title">
              {searchQuery ? 'Sonuç bulunamadı' : 'Henüz ürün yok'}
            </h3>
            <p className="product-empty-desc">
              {searchQuery
                ? `"${searchQuery}" aramasına uygun ürün bulunamadı.`
                : 'Bu kategoride kayıtlı ürün bulunmuyor. İlk ürünü ekleyerek başlayın.'}
            </p>
            {(isAdmin || isSatisci) && !isMontajci && !searchQuery && (
              <button type="button" className="btn-add-product-empty" onClick={handleAddNew}>
                <span className="btn-add-product-empty-icon">
                  <i className="fas fa-plus"></i>
                </span>
                İlk ürünü ekle
              </button>
            )}
          </div>
        ) : (
          <>
            <div className="product-table-container">
              <ProductListTable
                filteredProducts={filteredProducts}
                activeTypeTab={activeTypeTab}
                isAdmin={isAdmin}
                isSatisci={isSatisci}
                isMontajci={isMontajci}
                handleEdit={handleEdit}
                setDeleteModal={setDeleteModal}
                formatPrice={formatPrice}
              />
            </div>

            <div className="product-card-list">
              {filteredProducts.map((product, index) => (
                <div key={product.id} className="product-card">
                  <div className="product-card-header">
                    <span className="product-card-num">#{index + 1}</span>
                    <span className="product-card-name">{product.name}</span>
                    {(isAdmin || isSatisci) && !isMontajci && (
                      <div className="product-actions">
                        <button
                          className="action-btn edit"
                          onClick={() => handleEdit(product)}
                          title="Düzenle"
                        >
                          <i className="fas fa-edit"></i>
                        </button>
                        <button
                          className="action-btn delete"
                          onClick={() => setDeleteModal(product)}
                          title="Sil"
                        >
                          <i className="fas fa-trash-alt"></i>
                        </button>
                      </div>
                    )}
                  </div>
                  <div className="product-card-body">
                    {activeTypeTab === 'ahsapJaluzi' ? (
                      <div className="product-card-jaluzi-grid">
                        {[
                          { label: 'M. İpli', cost: product.merdivenIpliMaliyet, price: product.merdivenIpliFiyat, wholesale: product.merdivenIpliToptan },
                          { label: 'Kurdeleli', cost: product.kurdeleliMaliyet, price: product.kurdeleliFiyat, wholesale: product.kurdeleliToptan },
                          { label: 'M. İpli Red.', cost: product.merdivenIpliReduktorluMaliyet, price: product.merdivenIpliReduktorluFiyat, wholesale: product.merdivenIpliReduktorluToptan },
                          { label: 'Kur. Red.', cost: product.kurdelaliReduktorluMaliyet, price: product.kurdelaliReduktorluFiyat, wholesale: product.kurdelaliReduktorluToptan }
                        ].map((variant, i) => (
                          <div key={i} className="jaluzi-card-variant">
                            <span className="variant-label">{variant.label}</span>
                            <div className="variant-prices">
                              <span className="v-price cost" title="Maliyet">{variant.cost > 0 ? formatPrice(variant.cost) : '—'} ₺</span>
                              <span className="v-price retail" title="Perakende">{variant.price > 0 ? formatPrice(variant.price) : '—'} ₺</span>
                              <span className="v-price wholesale" title="Toptan">{variant.wholesale > 0 ? formatPrice(variant.wholesale) : '—'} ₺</span>
                            </div>
                          </div>
                        ))}
                      </div>
                    ) : activeTypeTab === 'katlamaliPerde' ? (
                      <>
                        {product.unitPrice > 0 && (
                          <span className="price-badge">M. İpli: {formatPrice(product.unitPrice)} ₺</span>
                        )}
                        {product.kurdeleliFiyat > 0 && (
                          <span className="price-badge">Kurdeleli: {formatPrice(product.kurdeleliFiyat)} ₺</span>
                        )}
                      </>
                    ) : activeTypeTab === 'rustik' ? (
                      <span className="product-card-type">Rustik Ürün</span>
                    ) : (
                      <>
                        {product.cost > 0 && (
                          <span className="cost-badge">Maliyet: {formatPrice(product.cost)} ₺</span>
                        )}
                        {product.unitPrice > 0 && (
                          <span className="price-badge">Satış: {formatPrice(product.unitPrice)} ₺</span>
                        )}
                        {product.wholesalePrice > 0 && (
                          <span className="price-badge wholesale-badge">Toptan: {formatPrice(product.wholesalePrice)} ₺</span>
                        )}
                      </>
                    )}
                  </div>
                </div>
              ))}
            </div>
          </>
        )}
      </div>

      {showForm && (
        <div className="modal-overlay" onClick={(e) => e.target === e.currentTarget && handleCancel()}>
          <div className="product-form-modal">
            <div className="modal-header">
              <h3>{editingProduct ? 'Ürün Düzenle' : 'Yeni Ürün Ekle'}</h3>
              <button className="modal-close" onClick={handleCancel}>
                <i className="fas fa-times"></i>
              </button>
            </div>

            <form onSubmit={handleSave} className="product-form">
              <div className="form-group">
                <label>Ürün Tipi *</label>
                <select
                  value={formData.productType}
                  onChange={(e) => setFormData(prev => ({ ...prev, productType: e.target.value }))}
                  disabled={isSaving}
                >
                  {Object.entries(PRODUCT_TYPES).map(([key, type]) => (
                    <option key={key} value={key}>{type.label}</option>
                  ))}
                </select>
              </div>

              <div className="form-group">
                <label>Ürün Adı *</label>
                <input
                  type="text"
                  value={formData.name}
                  onChange={(e) => setFormData(prev => ({ ...prev, name: e.target.value }))}
                  placeholder="örn. Karya Düz Tül"
                  disabled={isSaving}
                  autoFocus
                />
              </div>

              {(formData.productType === 'ahsapJaluzi') ? (
                <div className="jaluzi-price-grid">
                  <h5 className="section-subtitle">Dinamik Fiyatlandırma (₺)</h5>

                  <div className="jaluzi-grid-row form-row-3">
                    <div className="form-group">
                      <label>Merdiven İpli — Maliyet</label>
                      <input type="number" step="0.01" value={formData.merdivenIpliMaliyet}
                        onChange={(e) => setFormData(prev => ({ ...prev, merdivenIpliMaliyet: e.target.value }))}
                        disabled={isSaving} placeholder="0.00" />
                    </div>
                    <div className="form-group">
                      <label>Merdiven İpli — Satış</label>
                      <input type="number" step="0.01" value={formData.merdivenIpliFiyat}
                        onChange={(e) => setFormData(prev => ({ ...prev, merdivenIpliFiyat: e.target.value }))}
                        disabled={isSaving} placeholder="0.00" />
                    </div>
                    <div className="form-group">
                      <label><i className="fas fa-tags" style={{ color: '#f59e0b', marginRight: '4px' }}></i>Merdiven İpli — Toptan</label>
                      <input type="number" step="0.01" value={formData.merdivenIpliToptan}
                        onChange={(e) => setFormData(prev => ({ ...prev, merdivenIpliToptan: e.target.value }))}
                        disabled={isSaving} placeholder="0.00" style={{ borderColor: '#f59e0b' }} />
                    </div>
                  </div>

                  <div className="jaluzi-grid-row form-row-3">
                    <div className="form-group">
                      <label>Kurdeleli — Maliyet</label>
                      <input type="number" step="0.01" value={formData.kurdeleliMaliyet}
                        onChange={(e) => setFormData(prev => ({ ...prev, kurdeleliMaliyet: e.target.value }))}
                        disabled={isSaving} placeholder="0.00" />
                    </div>
                    <div className="form-group">
                      <label>Kurdeleli — Satış</label>
                      <input type="number" step="0.01" value={formData.kurdeleliFiyat}
                        onChange={(e) => setFormData(prev => ({ ...prev, kurdeleliFiyat: e.target.value }))}
                        disabled={isSaving} placeholder="0.00" />
                    </div>
                    <div className="form-group">
                      <label><i className="fas fa-tags" style={{ color: '#f59e0b', marginRight: '4px' }}></i>Kurdeleli — Toptan</label>
                      <input type="number" step="0.01" value={formData.kurdeleliToptan}
                        onChange={(e) => setFormData(prev => ({ ...prev, kurdeleliToptan: e.target.value }))}
                        disabled={isSaving} placeholder="0.00" style={{ borderColor: '#f59e0b' }} />
                    </div>
                  </div>

                  <div className="jaluzi-grid-row form-row-3">
                    <div className="form-group">
                      <label>M. İpli Redüktörlü — Maliyet</label>
                      <input type="number" step="0.01" value={formData.merdivenIpliReduktorluMaliyet}
                        onChange={(e) => setFormData(prev => ({ ...prev, merdivenIpliReduktorluMaliyet: e.target.value }))}
                        disabled={isSaving} placeholder="0.00" />
                    </div>
                    <div className="form-group">
                      <label>M. İpli Redüktörlü — Satış</label>
                      <input type="number" step="0.01" value={formData.merdivenIpliReduktorluFiyat}
                        onChange={(e) => setFormData(prev => ({ ...prev, merdivenIpliReduktorluFiyat: e.target.value }))}
                        disabled={isSaving} placeholder="0.00" />
                    </div>
                    <div className="form-group">
                      <label><i className="fas fa-tags" style={{ color: '#f59e0b', marginRight: '4px' }}></i>M. İpli Redüktörlü — Toptan</label>
                      <input type="number" step="0.01" value={formData.merdivenIpliReduktorluToptan}
                        onChange={(e) => setFormData(prev => ({ ...prev, merdivenIpliReduktorluToptan: e.target.value }))}
                        disabled={isSaving} placeholder="0.00" style={{ borderColor: '#f59e0b' }} />
                    </div>
                  </div>

                  <div className="jaluzi-grid-row form-row-3">
                    <div className="form-group">
                      <label>Kurdelalı Redüktörlü — Maliyet</label>
                      <input type="number" step="0.01" value={formData.kurdelaliReduktorluMaliyet}
                        onChange={(e) => setFormData(prev => ({ ...prev, kurdelaliReduktorluMaliyet: e.target.value }))}
                        disabled={isSaving} placeholder="0.00" />
                    </div>
                    <div className="form-group">
                      <label>Kurdelalı Redüktörlü — Satış</label>
                      <input type="number" step="0.01" value={formData.kurdelaliReduktorluFiyat}
                        onChange={(e) => setFormData(prev => ({ ...prev, kurdelaliReduktorluFiyat: e.target.value }))}
                        disabled={isSaving} placeholder="0.00" />
                    </div>
                    <div className="form-group">
                      <label><i className="fas fa-tags" style={{ color: '#f59e0b', marginRight: '4px' }}></i>Kurdelalı Redüktörlü — Toptan</label>
                      <input type="number" step="0.01" value={formData.kurdelaliReduktorluToptan}
                        onChange={(e) => setFormData(prev => ({ ...prev, kurdelaliReduktorluToptan: e.target.value }))}
                        disabled={isSaving} placeholder="0.00" style={{ borderColor: '#f59e0b' }} />
                    </div>
                  </div>

                </div>
              ) : formData.productType === 'rustik' ? (
                <div className="rustik-info-msg" style={{ marginBottom: '15px', color: '#64748b', fontSize: '0.85rem' }}>
                  <i className="fas fa-info-circle"></i> Rustik ürünleri için fiyatlandırma, sipariş sırasında ayak ve aksesuarlar üzerinden otomatik hesaplanır. Burada sadece ürün adı girilmelidir.
                </div>
              ) : (
                <div className="form-row-3">
                  <div className="form-group">
                    <label>Maliyet (₺)</label>
                    <input
                      type="number"
                      step="0.01"
                      min="0"
                      className="modern-settings-input"
                      value={formData.cost}
                      onChange={(e) => setFormData(prev => ({ ...prev, cost: e.target.value }))}
                      placeholder="0.00"
                      disabled={isSaving}
                    />
                  </div>

                  <div className="form-group">
                    <label>Birim Fiyat (Perakende - ₺) *</label>
                    <input
                      type="number"
                      step="0.01"
                      min="0"
                      className="modern-settings-input"
                      value={formData.unitPrice}
                      onChange={(e) => setFormData(prev => ({ ...prev, unitPrice: e.target.value }))}
                      placeholder="0.00"
                      disabled={isSaving}
                    />
                  </div>

                  <div className="form-group">
                    <label>
                      <i className="fas fa-tags" style={{ color: '#f59e0b', marginRight: '5px' }}></i>
                      Toptan Fiyat (₺)
                    </label>
                    <input
                      type="number"
                      step="0.01"
                      min="0"
                      className="modern-settings-input"
                      value={formData.wholesalePrice}
                      onChange={(e) => setFormData(prev => ({ ...prev, wholesalePrice: e.target.value }))}
                      placeholder="0.00"
                      disabled={isSaving}
                      style={{ borderColor: '#f59e0b' }}
                    />
                  </div>
                </div>
              )}

              {formError && (
                <div className="form-error">
                  <i className="fas fa-exclamation-circle"></i> {formError}
                </div>
              )}
              {formSuccess && (
                <div className="form-success">
                  <i className="fas fa-check-circle"></i> {formSuccess}
                </div>
              )}

              <div className="form-actions">
                <button type="button" className="btn-cancel" onClick={handleCancel} disabled={isSaving}>
                  İptal
                </button>
                <button type="submit" className="btn-save" disabled={isSaving}>
                  {isSaving ? (
                    <><i className="fas fa-spinner fa-spin"></i> Kaydediliyor...</>
                  ) : (
                    <><i className="fas fa-save"></i> {editingProduct ? 'Güncelle' : 'Kaydet'}</>
                  )}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {deleteModal && (
        <div className="modal-overlay" onClick={(e) => e.target === e.currentTarget && setDeleteModal(null)}>
          <div className="delete-modal">
            <div className="modal-header">
              <h3>Ürün Sil</h3>
              <button className="modal-close" onClick={() => setDeleteModal(null)}>
                <i className="fas fa-times"></i>
              </button>
            </div>
            <div className="delete-modal-body">
              <i className="fas fa-exclamation-triangle warning-icon"></i>
              <p>
                <strong>"{deleteModal.name}"</strong> adlı ürünü silmek istediğinizden emin misiniz?
              </p>
              <p className="delete-warning">Bu işlem geri alınamaz.</p>
            </div>
            <div className="delete-modal-actions">
              <button className="btn-cancel" onClick={() => setDeleteModal(null)}>
                İptal
              </button>
              <button className="btn-delete-confirm" onClick={handleDelete}>
                <i className="fas fa-trash"></i> Sil
              </button>
            </div>
          </div>
        </div>
      )}

      {excelModal.show && (
        <div className="modal-overlay" onClick={(e) => e.target === e.currentTarget && setExcelModal({ show: false })}>
          <div className="excel-modal">
            <div className="modal-header">
              <h3>{excelModal.title}</h3>
              <button className="modal-close" onClick={() => setExcelModal({ show: false })}>
                <i className="fas fa-times"></i>
              </button>
            </div>
            <div className="excel-modal-body">
              {excelModal.type === 'error' && <i className="fas fa-times-circle error-icon"></i>}
              {excelModal.type === 'success' && <i className="fas fa-check-circle success-icon"></i>}
              {excelModal.type === 'confirm' && <i className="fas fa-exclamation-triangle warning-icon"></i>}
              {excelModal.type === 'info' && <i className="fas fa-info-circle info-icon"></i>}
              {excelModal.type === 'confirm' && <h4>Onay Gerekiyor</h4>}
              <p style={{ whiteSpace: 'pre-line' }}>{excelModal.message}</p>
            </div>
            <div className="excel-modal-actions">
              {excelModal.type === 'confirm' ? (
                <>
                  <button className="btn-cancel" onClick={() => { setExcelModal({ show: false }); setIsExcelLoading(false); }}>
                    İptal
                  </button>
                  <button className="btn-save" onClick={excelModal.onConfirm}>
                    Evet, Yükle
                  </button>
                </>
              ) : (
                <button className="btn-save" onClick={() => setExcelModal({ show: false })}>
                  Tamam
                </button>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ProductList;
